import React, { useEffect, useState, useRef, Fragment } from "react"
import { useParams } from 'react-router'
import { useTranslation } from 'react-i18next'
import { Modal, Dropdown } from 'react-bootstrap'
import { useReactToPrint } from 'react-to-print';
import Select from 'react-select'
import XLSX from 'xlsx'

import Rightbar from 'pages/main/cheques/Rightbar'
import FilterPagination from 'pages/parts/FilterPagination'
import PeriodPicker from 'pages/parts/PeriodPicker'

import { httpOk, GET, POST } from 'helpers/api'
import MotivationProgramsTable from 'pages/parts/MotivationProgramsTable'
import { formatMoney, formatDate, returnSign, formatMoneyInput, findKeyFromArrayByValue, PAGE_SIZES } from 'helpers/helpers'
import CustomTooltip from "pages/parts/CustomTooltip";
import { renderMenuTreeRows, flattenMenuGroups, reportApiType } from 'pages/parts/menuTreeRows'
import { businessToday, businessMonthStart } from 'helpers/businessDay'

const THERMAL_PRINT_PAGE_STYLE = `
	@page {
		size: 80mm auto;
		margin: 2mm;
	}
	@media print {
		body {
			margin: 0;
			font-family: Arial, Helvetica, sans-serif;
			color: #000;
			-webkit-print-color-adjust: exact;
			print-color-adjust: exact;
		}
		.shift-thermal-print,
		.shift-thermal-print * {
			color: #000 !important;
			overflow: visible !important;
			height: auto !important;
			max-height: none !important;
		}
		.shift-thermal-print {
			width: 80mm !important;
			line-height: 1.25 !important;
		}
		.d-print-none {
			display: none !important;
		}
	}
`

function Shift() {
	const { t } = useTranslation()
	const { cashbox_id } = useParams()

	const printRef = useRef()

	const [data, setData] = useState([])
	const [activeTab, setActiveTab] = useState('x_report')
	const [showModal, setShowModal] = useState(false)
	const [showAcceptModal, setShowAcceptModal] = useState(false)
	const [showAcceptanceViewModal, setShowAcceptanceViewModal] = useState(false)
	const [acceptanceView, setAcceptanceView] = useState(null)
	const [acceptPayments, setAcceptPayments] = useState([])
	const [acceptNote, setAcceptNote] = useState('')
	const [acceptLoading, setAcceptLoading] = useState(false)
	const [acceptAccounts, setAcceptAccounts] = useState([])
	const [acceptEmployees, setAcceptEmployees] = useState([])
	const [acceptExpenseCashAmount, setAcceptExpenseCashAmount] = useState(0)
	const [acceptExpenseCashAccountId, setAcceptExpenseCashAccountId] = useState(null)
	const [acceptExpenseTerminalAmount, setAcceptExpenseTerminalAmount] = useState(0)
	const [acceptExpenseTerminalAccountId, setAcceptExpenseTerminalAccountId] = useState(null)
	const [acceptIncomeCashAmount, setAcceptIncomeCashAmount] = useState(0)
	const [acceptIncomeCashAccountId, setAcceptIncomeCashAccountId] = useState(null)
	const [acceptIncomeTerminalAmount, setAcceptIncomeTerminalAmount] = useState(0)
	const [acceptIncomeTerminalAccountId, setAcceptIncomeTerminalAccountId] = useState(null)
	const [acceptDifferenceDestination, setAcceptDifferenceDestination] = useState(null)
	const [acceptDifferenceAccountId, setAcceptDifferenceAccountId] = useState(null)
	const [acceptDifferenceEmployeeId, setAcceptDifferenceEmployeeId] = useState(null)
	const [showShiftExpenseIncomeModal, setShowShiftExpenseIncomeModal] = useState(false)
	const [shiftExpenseIncomeLoading, setShiftExpenseIncomeLoading] = useState(false)
	const [shiftExpenseIncomePpt, setShiftExpenseIncomePpt] = useState([])
	const [shiftExpenseIncomePaymentTypes, setShiftExpenseIncomePaymentTypes] = useState([])
	const [shiftExpenseIncomeCounterparties, setShiftExpenseIncomeCounterparties] = useState([])
	const [shiftExpenseIncomeForm, setShiftExpenseIncomeForm] = useState({
		transaction_type: 'minus',
		amount: '',
		note: '',
		payment_purpose_id: null,
		payment_type_id: null,
		counterparty: null,
		counterparty_id: null,
	})
	const [selectedItem, setSelectedItem] = useState({})
	const [expandedItems, setExpandedItems] = useState({})
	const [activeCashierLogin, setActiveCashierLogin] = useState('')
	const [showRightBar, setShowRightBar] = useState(false)
	const [rightbarItem, setRightbarItem] = useState({})
	const [reports, setReports] = useState([
		{ 'value': 'x_report', 'name': `X ${t('report')}` },
		{ 'value': 'menus', 'name': `${t('menu')}` },
		{ 'value': 'products', 'name': `${t('products')}` },
		{ 'value': 'preparation_places', 'name': `${t('preparation_places')}` },
		{ 'value': 'deleted_cheques', 'name': `${t('deleted_cheques')}` },
		{ 'value': 'deleted_products', 'name': `${t('deleted_products')}` },
		{ 'value': 'discount_cheques', 'name': `${t('discount_cheques')}` },
		{ 'value': 'order_types', 'name': `${t('order_types')}` },
		{ 'value': 'order_sub_types', 'name': `${t('delivery_types')}` },
		{ 'value': 'payment_types', 'name': `${t('payment_types')}` },
		{ 'value': 'expenses', 'name': `${t('take_money')}` },
		{ 'value': 'incomes', 'name': `${t('put_money')}` },
		{ 'value': 'clients', 'name': `${t('clients')}` },
		{ 'value': 'debtors', 'name': `${t('debtors')}` },
		{ 'value': 'motivation_programs', 'name': `${t('motivation_programs')}` },
		{ 'value': 'waiters', 'name': `${t('waiters_summary')}` },
		{ 'value': 'waiter_menus', 'name': `${t('waiters_menus')}` },
		{ 'value': 'waiter_products', 'name': `${t('waiter_products')}` },
		{ 'value': 'cashiers', 'name': `${t('cashiers_summary')}` },
		{ 'value': 'cashiers_x', 'name': `${t('cashiers_details')}` },
		{ 'value': 'couriers', 'name': `${t('couriers')}` },
		{ 'value': 'ingredients', 'name': `${t('ingredients')}` },
		{ 'value': 'products_ingredients', 'name': `${t('products_ingredients')}` },
	]);
	const [xReportData, setXreportData] = useState({
		"reports": {},
		"x_report": {},
	})
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [filterDataExist, setFilterDataExist] = useState(false)
	const [shiftStatuses] = useState([
		{ 'id': 'open', 'name': t('open') },
		{ 'id': 'closed', 'name': t('closed') },
		{ 'id': 'accepted', 'name': t('cashbox_accepted') },
		{ 'id': 'not_accepted', 'name': t('cashbox_not_accepted') },
	])
	const [filterData, setFilterData] = useState({
		start_date: businessMonthStart(),
		end_date: businessToday(),
		pos_id: null,
		status: null,
		size: 20,
		search: ''
	})
	const [pagination, setPagination] = useState({
		url: `/cashbox/shift/${cashbox_id}`,
		size: 20,
		response: null
	})

	async function searchWithFilter(passedFilterData = filterData) {
		var customFilterData = (passedFilterData && typeof passedFilterData === 'object') ? passedFilterData : filterData
		var filterUrl = `/cashbox/shift/${cashbox_id}`
		var urlParams = ""
		checkFilter()

		if (customFilterData.start_date)
			urlParams += returnSign(urlParams) + 'start_date=' + customFilterData.start_date
		if (customFilterData.end_date)
			urlParams += returnSign(urlParams) + 'end_date=' + customFilterData.end_date
		if (customFilterData.status)
			urlParams += returnSign(urlParams) + 'status=' + customFilterData.status
		if (customFilterData.size)
			urlParams += returnSign(urlParams) + 'size=' + customFilterData.size
		if (customFilterData.page)
			urlParams += returnSign(urlParams) + 'page=' + customFilterData.page

		if (`/cashbox/shift/${cashbox_id}${urlParams}` !== filterUrl)
			setFilterDataExist(true)

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			setPagination({ ...pagination, 'url': filterUrl, 'size': customFilterData.size, 'response': response.data })
		}

		setDropdownIsOpen(false)
	}

	async function toggleModalXreport(item) {
		setSelectedItem(item)
		var response = await GET(`/v1/report-x?pos_id=${item.pos_id}&cashbox_id=${item.cashbox_id}&shift_id=${item.id}&type=x_report`, {}, { loader: true })
		if (httpOk(response)) {
			var xReportDataCopy = { ...xReportData }
			var reportsCopy = [...reports]
			xReportDataCopy['x_report'] = response.data

			for (let i = 0; i < response?.data?.reports?.length; i++) {
				for (let j = 0; j < reportsCopy.length; j++) {
					if (reportsCopy[j]['value'] === response?.data?.reports[i]['value']) {
						reportsCopy[j]['active'] = response?.data?.reports[i]['active']
					}
				}
			}

			setReports(reportsCopy)
			setXreportData(xReportDataCopy)
			setActiveTab('x_report')
			setShowModal(true)
		}
	}

	function getCashiersXList() {
		const raw = xReportData?.cashiers_x
		if (Array.isArray(raw)) return raw
		if (Array.isArray(raw?.data)) return raw.data
		return []
	}

	function getActiveCashierX() {
		const list = getCashiersXList()
		if (!list.length) return null
		return list.find((item) => item.cashier_login === activeCashierLogin) || list[0]
	}

	async function toggleRightbar(boolean = false, item) {
		if (boolean) {
			const response = await GET(`/cheques/${item.cheque_id}`, {}, { loader: true })
			if (httpOk(response)) {
				setRightbarItem(response.data.data)
				setShowRightBar(boolean)
			}

		} else {
			setShowRightBar(boolean)
			setRightbarItem({})
		}
	}

	async function getData(type) {
		// Детализация бонуса мотиваций приходит в том же ответе: по меню, продукты внутри меню
		const withItems = type === 'motivation_programs' ? '&with_items=menu' : ''
		var response = await GET(`/v1/report-x?pos_id=${selectedItem.pos_id}&cashbox_id=${selectedItem.cashbox_id}&shift_id=${selectedItem.id}&type=${reportApiType(type)}${withItems}`, {}, { loader: true })
		if (httpOk(response)) {
			var xReportDataCopy = { ...xReportData }

			if (type === 'x_report') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'menus') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'products') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'preparation_places') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'deleted_cheques') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'deleted_products') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'discount_cheques') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'order_types') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'order_sub_types') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'payment_types') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'expenses') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'incomes') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'clients') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'debtors') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'waiters') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'waiter_menus') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'waiter_products') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'motivation_programs') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'cashiers') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'cashiers_x') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
				const list = Array.isArray(response.data)
					? response.data
					: (Array.isArray(response.data?.data) ? response.data.data : [])
				if (list.length > 0) {
					const stillExists = list.some((c) => c.cashier_login === activeCashierLogin)
					if (!stillExists) setActiveCashierLogin(list[0].cashier_login)
				}
			}
			if (type === 'couriers') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'ingredients') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'products_ingredients') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}

			setActiveTab(type)
			return response.data
		}
		return null
	}

	function getMotivationProgramRows(payload = {}) {
		const programs = Array.isArray(payload?.data)
			? payload.data
			: (Array.isArray(payload?.motivation_programs) ? payload.motivation_programs : [])
		const rows = []
		let totalSales = 0
		let totalBonus = 0

		programs.forEach((program) => {
			const users = Array.isArray(program?.users) ? program.users : []
			users.forEach((user) => {
				const sales = Number(user?.sales) || 0
				const bonus = Number(user?.bonus) || 0
				totalSales += sales
				totalBonus += bonus
				rows.push({
					program_name: program?.name ?? '',
					employee_name: user?.name ?? '',
					sales,
					bonus,
				})
			})
		})

		return { rows, totalSales, totalBonus }
	}

	function writeExcelFile(rows, sheetName, fileName) {
		const wb = XLSX.utils.book_new()
		const ws = XLSX.utils.aoa_to_sheet(rows)
		const safeSheet = String(sheetName || 'Sheet1').slice(0, 31)
		XLSX.utils.book_append_sheet(wb, ws, safeSheet)
		XLSX.writeFile(wb, fileName.endsWith('.xlsx') ? fileName : `${fileName}.xlsx`)
	}

	function flattenProductIngredients(items, level = 0, rows = [], counter = { n: 0 }) {
		; (items || []).forEach((item) => {
			if (!item.parent_id) counter.n += 1
			rows.push([
				item.parent_id ? '' : counter.n,
				`${'  '.repeat(level)}${item.name || ''}`,
				item.category_name || '',
				item.unit_name || '',
				Number(item.total_quantity) || 0,
			])
			if (item.children?.length) {
				flattenProductIngredients(item.children, level + 1, rows, counter)
			}
		})
		return rows
	}

	function buildTabExcelRows(type, payload) {
		const title = reports.find((r) => r.value === type)?.name || type
		const fileName = `${title}_${selectedItem?.id || ''}`

		const tableItems = (rowsType, data) => rowsType === 'menus' ? flattenMenuGroups(data) : (data || [])

		if (type === 'menus' || type === 'preparation_places' || type === 'order_types'
			|| type === 'order_sub_types' || type === 'clients' || type === 'cashiers' || type === 'couriers') {
			// заголовок первой колонки такой же, как в таблице на экране
			const nameColumns = {
				'menus': t('menu'),
				'preparation_places': t('preparation_places'),
				'order_types': t('order_type'),
				'order_sub_types': t('delivery_type'),
				'clients': t('client'),
				'cashiers': t('cashier'),
				'couriers': t('courier'),
			}
			const rows = [[nameColumns[type] || t('name2'), t('quantity'), t('amount')]]
				; tableItems(type, payload?.data).forEach((item) => {
					rows.push([
						item.name || '',
						Number(item.total_quantity) || 0,
						Number(item.total_amount) || 0,
					])
				})
			rows.push([
				t('total'),
				Number(payload?.total_quantity) || 0,
				Number(payload?.total_amount) || 0,
			])
			return { rows, sheetName: title, fileName }
		}

		if (type === 'products') {
			const rows = [[t('menu'), t('product'), t('quantity'), t('amount')]]
				; (payload?.data || []).forEach((item) => {
					rows.push([
						item.menu_name || '',
						item.name || '',
						Number(item.total_quantity) || 0,
						Number(item.total_amount) || 0,
					])
				})
			rows.push([
				t('total'),
				'',
				Number(payload?.total_quantity) || 0,
				Number(payload?.total_amount) || 0,
			])
			return { rows, sheetName: title, fileName }
		}

		if (type === 'deleted_cheques') {
			const rows = [['#', t('cashier'), t('waiter'), t('time'), '№', t('amount')]]
				; (payload?.data || []).forEach((item, index) => {
					rows.push([
						index + 1,
						item.cashier_name || '',
						item.waiter_name || '',
						item.cheque_closed_at ? formatDate(item.cheque_closed_at, 'HH:mm') : '',
						item.cheque_number || '',
						Number(item.total_amount) || 0,
					])
				})
			rows.push(['', t('total'), '', '', '', Number(payload?.total_amount) || 0])
			return { rows, sheetName: title, fileName }
		}

		if (type === 'discount_cheques') {
			const rows = [['#', t('cashier'), t('waiter'), t('time'), '№', t('discount'), t('amount')]]
				; (payload?.data || []).forEach((item, index) => {
					rows.push([
						index + 1,
						item.cashier_name || '',
						item.waiter_name || '',
						item.cheque_closed_at ? formatDate(item.cheque_closed_at, 'HH:mm') : '',
						item.cheque_number || '',
						Number(item.discount) || 0,
						Number(item.total_amount) || 0,
					])
				})
			rows.push([
				'',
				t('total'),
				'',
				'',
				'',
				Number(payload?.total_discount) || 0,
				Number(payload?.total_amount) || 0,
			])
			return { rows, sheetName: title, fileName }
		}

		if (type === 'deleted_products') {
			const rows = [[t('name2'), t('time'), '№', t('quantity'), t('amount')]]
				; (payload?.data || []).forEach((item) => {
					rows.push([
						item.name || '',
						item.created_at ? formatDate(item.created_at, 'HH:mm') : '',
						item.cheque_number || '',
						Number(item.quantity) || 0,
						Number(item.total_price) || 0,
					])
				})
			rows.push([
				t('total'),
				'',
				'',
				Number(payload?.total_quantity) || 0,
				Number(payload?.total_amount) || 0,
			])
			return { rows, sheetName: title, fileName }
		}

		if (type === 'expenses') {
			const rows = [[t('type'), t('counterparty'), t('note'), t('amount')]]
				; (payload?.data || []).forEach((item) => {
					rows.push([
						item.name || '',
						item.counterparty || '',
						item.note || '',
						Number(item.amount) || 0,
					])
				})
			rows.push([t('total'), '', '', Number(payload?.total_amount) || 0])
			return { rows, sheetName: title, fileName }
		}

		if (type === 'incomes') {
			const rows = [[t('type'), t('counterparty'), t('amount')]]
				; (payload?.data || []).forEach((item) => {
					rows.push([
						item.name || '',
						item.counterparty || '',
						Number(item.amount) || 0,
					])
				})
			rows.push([t('total'), '', Number(payload?.total_amount) || 0])
			return { rows, sheetName: title, fileName }
		}

		if (type === 'debtors') {
			const rows = [[t('client'), t('counterparty'), t('amount')]]
				; (payload?.data || []).forEach((item) => {
					rows.push([
						item.name || '',
						returnEntityType(item),
						Number(item.total_amount) || 0,
					])
				})
			rows.push([t('total'), '', Number(payload?.total_amount) || 0])
			return { rows, sheetName: title, fileName }
		}

		if (type === 'waiters') {
			const rows = [[t('waiter'), t('quantity'), t('service'), t('amount')]]
				; (payload?.data || []).forEach((item) => {
					rows.push([
						item.name || '',
						Number(item.total_quantity) || 0,
						Number(item.total_service_amount) || 0,
						Number(item.total_amount) || 0,
					])
				})
			rows.push([
				t('total'),
				Number(payload?.total_quantity) || 0,
				Number(payload?.total_service_amount) || 0,
				Number(payload?.total_amount) || 0,
			])
			return { rows, sheetName: title, fileName }
		}

		if (type === 'waiter_menus' || type === 'waiter_products') {
			const childKey = type === 'waiter_menus' ? 'menus' : 'products'
			const rows = [[t('waiter'), t('name2'), t('quantity'), t('amount')]]
				; (payload?.data || []).forEach((waiter) => {
					; (type === 'waiter_menus' ? flattenMenuGroups(waiter?.groups) : (waiter?.[childKey] || [])).forEach((item) => {
						rows.push([
							waiter.name || '',
							item.name || '',
							Number(item.total_quantity) || 0,
							Number(item.total_amount) || 0,
						])
					})
					rows.push([
						waiter.name || '',
						t('total'),
						Number(waiter.total_quantity) || 0,
						Number(waiter.total_amount) || 0,
					])
					rows.push(['', '', '', ''])
				})
			return { rows, sheetName: title, fileName }
		}

		if (type === 'motivation_programs') {
			const motivationData = getMotivationProgramRows(payload)
			const rows = [[t('employee'), t('name2'), t('amount'), t('bonus')]]
			motivationData.rows.forEach((item) => {
				rows.push([
					item.program_name || '',
					item.employee_name || '',
					Number(item.sales) || 0,
					Number(item.bonus) || 0,
				])
			})
			rows.push([
				t('total'),
				'',
				Number(motivationData.totalSales) || 0,
				Number(motivationData.totalBonus) || 0,
			])
			return { rows, sheetName: title, fileName }
		}

		if (type === 'ingredients') {
			const rows = [['#', t('element'), t('category'), t('unit'), t('quantity')]]
				; (payload?.data || []).forEach((item, index) => {
					rows.push([
						index + 1,
						item.name || '',
						item.category_name || '',
						item.unit_name || '',
						Number(item.total_quantity) || 0,
					])
				})
			rows.push(['', t('total'), '', '', Number(payload?.total_quantity) || 0])
			return { rows, sheetName: title, fileName }
		}

		if (type === 'products_ingredients') {
			const rows = [['#', t('product'), t('category'), t('unit'), t('quantity')]]
			flattenProductIngredients(payload?.data || [], 0, rows)
			return { rows, sheetName: title, fileName }
		}

		return null
	}

	async function exportTabExcel(type, e) {
		e?.stopPropagation?.()
		e?.preventDefault?.()
		if (!selectedItem?.id) return

		if (type === 'x_report') {
			let report = xReportData?.x_report
			if (!report?.shift_id) {
				report = await getData(type)
			}
			exportXReportExcel(report)
			return
		}
		if (type === 'cashiers_x') {
			await exportCashiersPaymentsExcel(e)
			return
		}
		if (type === 'payment_types') {
			await exportToExcelItems(e)
			return
		}

		let payload = xReportData?.[type]
		const hasData = type === 'motivation_programs'
			? (Array.isArray(payload?.data) || Array.isArray(payload?.motivation_programs))
			: Array.isArray(payload?.data)
		if (!hasData) {
			payload = await getData(type)
		}

		const built = buildTabExcelRows(type, payload)
		if (!built?.rows?.length) return
		writeExcelFile(built.rows, built.sheetName, built.fileName)
	}

	async function exportToExcelItems(e) {
		e?.stopPropagation?.()
		e?.preventDefault?.()
		if (!selectedItem?.id) return

		var filterUrl = `/api/v1/shifts/${selectedItem.id}/payments/excel`

		var excelHeaders = [['ID', t('amount'), t('discount')]]
		const response = await GET(filterUrl, {}, { loader: true })

		if (httpOk(response)) {
			for (let i = 0; i < response.data.data.length; i++) {
				var item = response.data.data[i]
				var excelItems = []
				excelItems.push(item.cheque_id)
				excelItems.push(Number(item.amount))
				excelItems.push(Number(item.discount))
				excelHeaders.push(excelItems)
			}

			for (let i = 0; i < response.data.payments.length; i++) {
				var payment = response.data.payments[i]
				var excelPayments = []
				excelPayments.push(payment.name)
				excelPayments.push(Number(payment.amount))
				excelHeaders.push(excelPayments)
			}

			const ws = XLSX.utils.aoa_to_sheet(excelHeaders);
			const wb = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
			XLSX.writeFile(wb, t('payment') + ".xlsx");
		}
	}

	function exportXReportExcel(reportParam) {
		const report = reportParam || xReportData?.x_report
		if (!report || !report.shift_id) return

		const rows = [
			[t('pos'), report.pos_name || ''],
			[t('cashbox'), report.cashbox_name || ''],
			[`${t('shift')} ID`, report.shift_id || ''],
			[t('shift_number'), report.shift_number || ''],
			[t('cashier'), report.cashier_name || ''],
			[t('start_of_shift'), report.opened_at ? formatDate(report.opened_at, 'dd.MM.yy HH:mm') : ''],
			[t('end_of_shift'), report.closed_at ? formatDate(report.closed_at, 'dd.MM.yy HH:mm') : ''],
			[],
			[`${t('number_of_checks')} [ ${t('hall')} ]`, Number(report.count_hall) || 0],
			[`${t('number_of_checks')} [ ${t('takeaway')} ]`, Number(report.count_takeaway) || 0],
			[`${t('number_of_checks')} [ ${t('delivery')} ]`, Number(report.count_delivery) || 0],
			[t('number_of_checks'), Number(report.count_cheques) || 0],
		]

		if (report.count_deleted_cheques) {
			rows.push([t('deleted_cheques'), Number(report.count_deleted_cheques) || 0])
			rows.push([t('deleted_products'), Number(report.count_deleted_products) || 0])
		}

		rows.push([])
		rows.push([t('sales'), Number(report.sales) || 0])
		rows.push([t('service'), Number(report.service_percentage_amount) || 0])
		rows.push([t('delivery'), Number(report.total_delivery_amount) || 0])
		rows.push([t('sales_amount'), Number(report.total_sales) || 0])
		rows.push([t('discount'), Number(report.total_discount) || 0])
		rows.push([t('debt'), Number(report.total_debt_amount) || 0])
		if (report.loyalty) {
			rows.push([t('loyalty'), Number(report.loyalty) || 0])
		}
		rows.push([
			t('total'),
			(Number(report.total_discount) || 0) + (Number(report.total_debt_amount) || 0),
		])
		rows.push([t('total_checkout'), Number(report.total_payments) || 0])
		rows.push([])

			; (report.payments || []).forEach((item) => {
				const name = [item.payment_type_name, item.payment_purpose_name]
					.filter(Boolean)
					.join(' ')
				const amount = Number(item.amount) || 0
				rows.push([
					name,
					item.transaction_type === 'minus' ? -Math.abs(amount) : amount,
				])
			})

		if (report.total_cash) {
			rows.push([t('total_cash'), Number(report.total_cash) || 0])
		}
		if (report.total_bank) {
			rows.push([t('total_bank'), Number(report.total_bank) || 0])
		}
		if (report.total_expense) {
			rows.push([t('total_expense'), Number(report.total_expense) || 0])
		}

		rows.push([])
		rows.push([t('cashbox_balance'), Number(report.balance) || 0])

		const ws = XLSX.utils.aoa_to_sheet(rows)
		const wb = XLSX.utils.book_new()
		XLSX.utils.book_append_sheet(wb, ws, `X ${t('report')}`)
		XLSX.writeFile(wb, `X_${t('report')}_${report.shift_id}.xlsx`)
	}

	async function exportCashiersPaymentsExcel(e) {
		e?.stopPropagation?.()
		e?.preventDefault?.()
		if (!selectedItem?.id) return

		const response = await GET(
			`/api/v1/shifts/${selectedItem.id}/cashiers-payments/excel?pos_id=${selectedItem.pos_id}`,
			{},
			{ loader: true }
		)
		if (!httpOk(response)) return

		const rows = Array.isArray(response.data?.data) ? response.data.data : []
		const excelRows = [[
			t('cashier'),
			t('name2'),
			t('quantity'),
			t('amount'),
		]]

		let prevCashier = null
		let cashierQty = 0
		let cashierAmount = 0
		let totalQty = 0
		let totalAmount = 0

		const pushCashierTotal = () => {
			if (prevCashier === null) return
			excelRows.push([
				prevCashier,
				t('total'),
				cashierQty,
				cashierAmount,
			])
			excelRows.push(['', '', '', ''])
		}

		rows.forEach((row) => {
			const cashierName = row.cashier_name || row.cashier_login || ''
			if (prevCashier !== null && prevCashier !== cashierName) {
				pushCashierTotal()
				cashierQty = 0
				cashierAmount = 0
			}
			prevCashier = cashierName
			const qty = Number(row.total_quantity) || 0
			const amount = Number(row.total_amount) || 0
			cashierQty += qty
			cashierAmount += amount
			totalQty += qty
			totalAmount += amount
			excelRows.push([
				cashierName,
				row.name || '',
				qty,
				amount,
			])
		})
		pushCashierTotal()
		excelRows.push([
			t('total'),
			'',
			totalQty,
			totalAmount,
		])

		const wb = XLSX.utils.book_new()
		const ws = XLSX.utils.aoa_to_sheet(excelRows)
		ws['!cols'] = [
			{ wch: 40 },
			{ wch: 28 },
			{ wch: 12 },
			{ wch: 18 },
		]
		XLSX.utils.book_append_sheet(wb, ws, t('payment_types') || 'payment_types')
		XLSX.writeFile(wb, `${t('cashiers_details')}_${selectedItem.id}.xlsx`)
	}

	const handlePrint = useReactToPrint({
		content: () => printRef.current,
		pageStyle: THERMAL_PRINT_PAGE_STYLE,
	})

	async function printTabReport(type, e) {
		e?.stopPropagation?.()
		e?.preventDefault?.()
		if (activeTab !== type) {
			await getData(type)
		}
		setTimeout(() => {
			handlePrint()
		}, 350)
	}

	function isShiftAccepted(item) {
		return Number(item?.status) === 2
	}

	function canAcceptShift(item) {
		return !!(item?.closed_at) && !isShiftAccepted(item)
	}

	function resetShiftExpenseIncomeForm(transactionType = 'minus') {
		setShiftExpenseIncomeForm({
			transaction_type: transactionType,
			amount: '',
			note: '',
			payment_purpose_id: null,
			payment_type_id: null,
			counterparty: null,
			counterparty_id: null,
		})
		setShiftExpenseIncomeCounterparties([])
	}

	async function loadShiftExpenseIncomeHelpers(transactionType = 'minus', posId = null) {
		const pptUrl = transactionType === 'plus' ? '/helper/ppt-income' : '/helper/ppt-expense'
		const [pptResponse, paymentTypesResponse] = await Promise.all([
			GET(pptUrl),
			shiftExpenseIncomePaymentTypes.length
				? Promise.resolve({ status: 200, data: shiftExpenseIncomePaymentTypes })
				: GET('/helper/payment-types'),
		])
		if (httpOk(pptResponse)) setShiftExpenseIncomePpt(pptResponse.data || [])
		if (httpOk(paymentTypesResponse)) setShiftExpenseIncomePaymentTypes(paymentTypesResponse.data || [])
		return { posId }
	}

	async function openShiftExpenseIncomeModal(item, e) {
		if (e) e.stopPropagation()
		if (!canAcceptShift(item)) return

		setSelectedItem(item)
		resetShiftExpenseIncomeForm('minus')
		setShiftExpenseIncomeLoading(true)
		await loadShiftExpenseIncomeHelpers('minus', item.pos_id)
		setShiftExpenseIncomeLoading(false)
		setShowShiftExpenseIncomeModal(true)
	}

	async function changeShiftExpenseIncomeType(transactionType) {
		resetShiftExpenseIncomeForm(transactionType)
		setShiftExpenseIncomeLoading(true)
		await loadShiftExpenseIncomeHelpers(transactionType, selectedItem?.pos_id)
		setShiftExpenseIncomeLoading(false)
	}

	async function handleShiftExpenseIncomePpt(option) {
		const counterparty = option?.counterparty || null
		setShiftExpenseIncomeForm((prev) => ({
			...prev,
			payment_purpose_id: option ? option.id : null,
			counterparty,
			counterparty_id: null,
		}))
		setShiftExpenseIncomeCounterparties([])

		if (!counterparty) return

		let url = null
		if (counterparty === 'supplier') url = '/helper/suppliers'
		if (counterparty === 'employee' || counterparty === 'employee_salary') {
			url = `/helper/employees?pos_id=${selectedItem?.pos_id || ''}`
		}
		if (counterparty === 'client') url = '/helper/clients'
		if (counterparty === 'organization') url = '/helper/organizations'
		if (!url) return

		const response = await GET(url)
		if (httpOk(response)) setShiftExpenseIncomeCounterparties(response.data || [])
	}

	async function submitShiftExpenseIncome(e) {
		e.preventDefault()
		if (!selectedItem?.id || shiftExpenseIncomeLoading) return

		const amount = Number(shiftExpenseIncomeForm.amount) || 0
		if (amount <= 0 || !shiftExpenseIncomeForm.payment_purpose_id) return
		if (shiftExpenseIncomeForm.counterparty && !shiftExpenseIncomeForm.counterparty_id) return

		const isExpense = shiftExpenseIncomeForm.transaction_type !== 'plus'
		const defaultNote = isExpense
			? 'Расход внесён после закрытия смены'
			: 'Приход внесён после закрытия смены'
		const note = (shiftExpenseIncomeForm.note || '').trim() || defaultNote

		const payload = {
			shift_id: selectedItem.id,
			cashbox_id: selectedItem.cashbox_id,
			pos_id: selectedItem.pos_id,
			amount,
			note,
			payment_purpose_id: shiftExpenseIncomeForm.payment_purpose_id,
			payment_type_id: shiftExpenseIncomeForm.payment_type_id || 1,
			created_at: selectedItem.closed_at || null,
		}

		const counterparty = shiftExpenseIncomeForm.counterparty
		if (counterparty === 'supplier') payload.supplier_id = shiftExpenseIncomeForm.counterparty_id
		if (counterparty === 'employee' || counterparty === 'employee_salary') {
			payload.employee_id = shiftExpenseIncomeForm.counterparty_id
		}
		if (counterparty === 'client') payload.client_id = shiftExpenseIncomeForm.counterparty_id
		if (counterparty === 'organization') payload.organization_id = shiftExpenseIncomeForm.counterparty_id

		const url = shiftExpenseIncomeForm.transaction_type === 'plus' ? '/shift-income' : '/shift-expense'
		setShiftExpenseIncomeLoading(true)
		const response = await POST(url, payload, { loader: true })
		setShiftExpenseIncomeLoading(false)

		if (httpOk(response)) {
			setShowShiftExpenseIncomeModal(false)
			resetShiftExpenseIncomeForm('minus')
			searchWithFilter()
		}
	}

	// Плоский список счетов -> дерево: отступ по уровню.
	// Не выбираются только самые верхние корни («Активы» и т.п.); остальные узлы — можно выбрать.
	function buildAccountOptions(accounts = []) {
		const childrenOf = {}
		const known = new Set(accounts.map((item) => Number(item.id)))

		accounts.forEach((item) => {
			// родитель вне выборки (корень «Активы» и т.п.) — считаем узел верхним
			const parentId = known.has(Number(item.parent_id)) ? Number(item.parent_id) : null
			if (!childrenOf[parentId]) childrenOf[parentId] = []
			childrenOf[parentId].push(item)
		})

		const options = []
		const walk = (parentId, level) => {
			(childrenOf[parentId] || []).forEach((item) => {
				options.push({
					...item,
					level,
					isDisabled: level === 0,
					treeLabel: `${'\u00A0\u00A0\u00A0\u00A0'.repeat(level)}${item.name}${item.code ? ` (${item.code})` : ''}`,
				})
				walk(Number(item.id), level + 1)
			})
		}
		walk(null, 0)

		return options
	}

	const accountOptions = buildAccountOptions(acceptAccounts)

	const accountSelectProps = {
		options: accountOptions,
		menuPosition: 'fixed',
		menuPortalTarget: typeof document !== 'undefined' ? document.body : null,
		menuPlacement: 'auto',
		styles: { menuPortal: (base) => ({ ...base, zIndex: 9999 }) },
		placeholder: '',
		noOptionsMessage: () => t('list_empty'),
		getOptionLabel: (option) => option.treeLabel || option.name,
		getOptionValue: (option) => option.id,
		isOptionDisabled: (option) => !!option.isDisabled,
	}

	async function openAcceptanceViewModal(item, e) {
		if (e) e.stopPropagation()
		if (!item?.id) return

		setSelectedItem(item)
		const reportBase = `/v1/report-x?pos_id=${item.pos_id}&cashbox_id=${item.cashbox_id}&shift_id=${item.id}`
		const [response, incomesResponse, expensesResponse] = await Promise.all([
			GET(`/shift-accept/${item.id}`, {}, { loader: true }),
			GET(`${reportBase}&type=incomes`),
			GET(`${reportBase}&type=expenses`),
		])
		if (!httpOk(response)) return

		const data = { ...(response.data || {}) }
		const expenseTotals = sumCashboxFlowByCategory(
			httpOk(expensesResponse) ? (expensesResponse.data?.data || []) : []
		)
		const incomeTotals = sumCashboxFlowByCategory(
			httpOk(incomesResponse) ? (incomesResponse.data?.data || []) : []
		)

		// Старые принятия без колонок изъятия/внесения — подставляем из отчёта смены
		const hasSavedFlow =
			Number(data.expense_cash_amount) > 0
			|| Number(data.expense_terminal_amount) > 0
			|| Number(data.income_cash_amount) > 0
			|| Number(data.income_terminal_amount) > 0
			|| data.expense_cash_account_id
			|| data.expense_terminal_account_id
			|| data.income_cash_account_id
			|| data.income_terminal_account_id

		if (!hasSavedFlow) {
			data.expense_cash_amount = expenseTotals.cash
			data.expense_terminal_amount = expenseTotals.bank
			data.income_cash_amount = incomeTotals.cash
			data.income_terminal_amount = incomeTotals.bank
		}

		// Факт по типам оплат — из строк принятия (не путать с внесением)
		let factCash = 0
		let factBank = 0
		;(data.payments || []).forEach((row) => {
			const categoryId = Number(row.payment_type_category_id)
			const fact = Number(row.fact_amount) || 0
			if (categoryId === 1) factCash += fact
			if (categoryId === 2 || categoryId === 5) factBank += fact
		})
		if ((data.payments || []).length > 0) {
			data.cash_amount = factCash
			data.bank_amount = factBank
		}

		setAcceptanceView(data)
		setShowAcceptanceViewModal(true)
	}

	function buildAcceptPayments(report = {}, shiftItem = selectedItem, defaults = {}) {
		const defaultCashId = defaults.account_cash_id || null
		const defaultTerminalId = defaults.account_terminal_id || null
		// Принятие: только оплаты чеков (cheque_payments), X-отчёт payments не трогаем
		const payments = Array.isArray(report?.cheque_payments)
			? report.cheque_payments
			: (Array.isArray(report?.payments) ? report.payments : [])
		const byType = {}

		const ensureRow = (paymentTypeId, categoryId, name) => {
			const key = String(paymentTypeId)
			if (!byType[key]) {
				byType[key] = {
					payment_type_id: paymentTypeId,
					payment_type_category_id: categoryId,
					payment_type_name: name || '',
					income_amount: 0,
					expense_amount: 0,
					account_id: Number(categoryId) === 1 ? defaultCashId : defaultTerminalId,
				}
			}
			return byType[key]
		}

		// Верхняя таблица принятия: только оплаты чеков (cheque_payments)
		payments.forEach((item) => {
			const amount = Number(item.amount) || 0
			if (amount <= 0) return
			const tt = item.transaction_type
			if (tt !== 'plus' && tt !== 'minus') return

			const categoryId = Number(item.payment_type_category_id) || 0
			const paymentTypeId = item.payment_type_id
			const name = item.payment_type_name || ''
			if (!paymentTypeId) return
			if (categoryId !== 1 && categoryId !== 2 && categoryId !== 5) return

			const row = ensureRow(paymentTypeId, categoryId, name)
			if (tt === 'plus') row.income_amount += amount
			if (tt === 'minus') row.expense_amount += amount
		})

		// Сдача выдана из кассы наличными — в оплатах чеков её нет, вычитаем из первой наличной строки
		// Источник — строки движений смены «Сдача» (назначение 2, без типа оплаты, расход); cheques.change часто пустой
		const allShiftPayments = Array.isArray(report?.payments) ? report.payments : []
		const changeRows = allShiftPayments.filter((item) =>
			Number(item.payment_purpose_id) === 2
			&& !Number(item.payment_type_category_id)
			&& item.transaction_type === 'minus'
		)
		const totalChange = changeRows.length > 0
			? changeRows.reduce((sum, item) => sum + (Number(item.amount) || 0), 0)
			: (Number(report?.total_change) || 0)
		if (totalChange > 0) {
			const cashRow = Object.values(byType).find((row) => Number(row.payment_type_category_id) === 1)
			if (cashRow) cashRow.expense_amount += totalChange
		}

		const rows = Object.values(byType)
			.map((row) => {
				const systemAmount = Number(row.income_amount) - Number(row.expense_amount)
				return {
					...row,
					income_amount: Number(row.income_amount) || 0,
					expense_amount: Number(row.expense_amount) || 0,
					system_amount: systemAmount,
					amount: systemAmount,
				}
			})
			.filter((row) => row.income_amount > 0 || row.expense_amount > 0)

		if (rows.length > 0) return rows

		const cashAmount = Number(report?.total_cash ?? report?.balance ?? shiftItem?.balance) || 0
		const bankAmount = Number(report?.total_bank) || 0
		const fallback = []
		if (cashAmount) {
			fallback.push({
				payment_type_id: 1,
				payment_type_category_id: 1,
				payment_type_name: t('cash'),
				income_amount: cashAmount,
				expense_amount: 0,
				system_amount: cashAmount,
				amount: cashAmount,
				account_id: defaultCashId,
			})
		}
		if (bankAmount) {
			fallback.push({
				payment_type_id: 2,
				payment_type_category_id: 2,
				payment_type_name: t('terminal'),
				income_amount: bankAmount,
				expense_amount: 0,
				system_amount: bankAmount,
				amount: bankAmount,
				account_id: defaultTerminalId,
			})
		}
		return fallback
	}

	function getAcceptTotals(payments = acceptPayments, shiftItem = selectedItem, report = xReportData?.x_report) {
		let systemCash = 0
		let factCash = 0
		let systemBank = 0
		let factBank = 0
		let cashIncome = 0
		let cashExpense = 0
		let bankIncome = 0
		let bankExpense = 0

		payments.forEach((item) => {
			const categoryId = Number(item.payment_type_category_id)
			const systemAmount = Number(item.system_amount) || 0
			const factAmount = Number(item.amount) || 0
			const income = Number(item.income_amount) || 0
			const expense = Number(item.expense_amount) || 0
			if (categoryId === 1) {
				systemCash += systemAmount
				factCash += factAmount
				cashIncome += income
				cashExpense += expense
			}
			if (categoryId === 2 || categoryId === 5) {
				systemBank += systemAmount
				factBank += factAmount
				bankIncome += income
				bankExpense += expense
			}
		})

		// Система = приход − расход (ожидаемый остаток). На счёт уходит факт с поправкой.
		const systemCashToAccount = systemCash
		const systemBankToAccount = systemBank
		const cashToAccount = systemCashToAccount + (factCash - systemCash)
		const bankToAccount = factBank

		return {
			systemCash,
			factCash,
			systemBank,
			factBank,
			cashIncome,
			cashExpense,
			bankIncome,
			bankExpense,
			systemCashToAccount,
			systemBankToAccount,
			cashToAccount,
			bankToAccount,
			difference: (cashToAccount + bankToAccount) - (systemCashToAccount + systemBankToAccount),
			shiftBalance: Number(shiftItem?.balance ?? report?.balance) || 0,
		}
	}

	function sumCashboxFlowByCategory(rows = []) {
		let cash = 0
		let bank = 0
		;(Array.isArray(rows) ? rows : []).forEach((item) => {
			const amount = Number(item.amount) || 0
			if (amount <= 0) return
			const categoryId = Number(item.payment_type_category_id) || 0
			if (categoryId === 2 || categoryId === 5) {
				bank += amount
				return
			}
			// Без типа оплаты / наличка — в наличные
			cash += amount
		})
		return { cash, bank }
	}

	async function openAcceptModal(item, e) {
		if (e) e.stopPropagation()
		if (!canAcceptShift(item)) return

		setSelectedItem(item)
		setAcceptNote('')
		setAcceptExpenseCashAmount(0)
		setAcceptExpenseCashAccountId(null)
		setAcceptExpenseTerminalAmount(0)
		setAcceptExpenseTerminalAccountId(null)
		setAcceptIncomeCashAmount(0)
		setAcceptIncomeCashAccountId(null)
		setAcceptIncomeTerminalAmount(0)
		setAcceptIncomeTerminalAccountId(null)
		setAcceptDifferenceDestination(null)
		setAcceptDifferenceAccountId(null)
		setAcceptDifferenceEmployeeId(null)
		setAcceptLoading(true)

		const reportBase = `/v1/report-x?pos_id=${item.pos_id}&cashbox_id=${item.cashbox_id}&shift_id=${item.id}`
		const [reportResponse, incomesResponse, expensesResponse, accountsResponse, employeesResponse, cashboxResponse] = await Promise.all([
			GET(`${reportBase}&type=x_report`, {}, { loader: true }),
			GET(`${reportBase}&type=incomes`),
			GET(`${reportBase}&type=expenses`),
			acceptAccounts.length ? Promise.resolve({ status: 200, data: acceptAccounts }) : GET('/helper/accounts'),
			GET(`/helper/employees?pos_id=${item.pos_id}`),
			GET('/cashbox'),
		])

		setAcceptLoading(false)

		if (httpOk(accountsResponse)) setAcceptAccounts(accountsResponse.data || [])
		if (httpOk(employeesResponse)) setAcceptEmployees(employeesResponse.data || [])
		else setAcceptEmployees([])
		const cashboxes = httpOk(cashboxResponse) ? (cashboxResponse.data || []) : []
		const cashbox = cashboxes.find((c) => Number(c.id) === Number(item.cashbox_id))
		const accountDefaults = {
			account_cash_id: cashbox?.account_cash_id || null,
			account_terminal_id: cashbox?.account_terminal_id || null,
		}
		setAcceptIncomeCashAccountId(accountDefaults.account_cash_id)
		setAcceptIncomeTerminalAccountId(accountDefaults.account_terminal_id)
		setAcceptExpenseCashAccountId(accountDefaults.account_cash_id)
		setAcceptExpenseTerminalAccountId(accountDefaults.account_terminal_id)

		const employees = httpOk(employeesResponse) ? (employeesResponse.data || []) : acceptEmployees
		const cashierEmployee = employees.find((emp) => emp.login === item.cashier_login)
		if (cashierEmployee) setAcceptDifferenceEmployeeId(cashierEmployee.id)

		if (httpOk(reportResponse)) {
			setXreportData({ ...xReportData, x_report: reportResponse.data })
			const payments = buildAcceptPayments(reportResponse.data, item, accountDefaults)
			setAcceptPayments(payments)

			// Расход / Приход — только операции кассы (expenses minus/plus), не продажи по типам оплат
			const expenseRows = httpOk(expensesResponse) ? (expensesResponse.data?.data || []) : []
			const incomeRows = httpOk(incomesResponse) ? (incomesResponse.data?.data || []) : []
			const expenseTotals = sumCashboxFlowByCategory(expenseRows)
			const incomeTotals = sumCashboxFlowByCategory(incomeRows)
			setAcceptExpenseCashAmount(expenseTotals.cash)
			setAcceptExpenseTerminalAmount(expenseTotals.bank)
			setAcceptIncomeCashAmount(incomeTotals.cash)
			setAcceptIncomeTerminalAmount(incomeTotals.bank)
			setShowAcceptModal(true)
		}
	}

	function changeAcceptPaymentAmount(index, value) {
		const next = [...acceptPayments]
		next[index] = {
			...next[index],
			amount: value === '' ? '' : Number(value),
		}
		setAcceptPayments(next)
	}

	function changeAcceptPaymentAccount(index, accountId) {
		const next = [...acceptPayments]
		next[index] = {
			...next[index],
			account_id: accountId || null,
		}
		setAcceptPayments(next)
	}

	async function submitAcceptShift(e) {
		e.preventDefault()
		if (!selectedItem?.id || acceptLoading) return

		const totals = getAcceptTotals()
		const shortageAmount = totals.difference < 0 ? Math.abs(totals.difference) : 0
		const surplusAmount = totals.difference > 0 ? totals.difference : 0

		const expenseCashAmount = Number(acceptExpenseCashAmount) || 0
		const expenseTerminalAmount = Number(acceptExpenseTerminalAmount) || 0
		const incomeCashAmount = Number(acceptIncomeCashAmount) || 0
		const incomeTerminalAmount = Number(acceptIncomeTerminalAmount) || 0

		const paymentMissingAccount = acceptPayments.some((item) => {
			const incomeAmount = Number(item.income_amount) || 0
			const factAmount = Number(item.amount) || 0
			const needsAccount = incomeAmount > 0 || factAmount > 0
			return needsAccount && !item.account_id
		})
		if (paymentMissingAccount) return
		if (expenseCashAmount > 0 && !acceptExpenseCashAccountId) return
		if (expenseTerminalAmount > 0 && !acceptExpenseTerminalAccountId) return
		if (incomeCashAmount > 0 && !acceptIncomeCashAccountId) return
		if (incomeTerminalAmount > 0 && !acceptIncomeTerminalAccountId) return

		if (shortageAmount > 0) {
			if (!acceptDifferenceDestination) return
			if (acceptDifferenceDestination === 'account' && !acceptDifferenceAccountId) return
			if (acceptDifferenceDestination === 'employee_debt' && !acceptDifferenceEmployeeId) return
		}
		if (surplusAmount > 0) {
			if (!acceptDifferenceAccountId) return
		}

		let differencePayload = {
			amount: 0,
			type: null,
			destination: null,
			account_id: null,
			employee_id: null,
		}
		if (shortageAmount > 0) {
			differencePayload = {
				amount: shortageAmount,
				type: 'shortage',
				destination: acceptDifferenceDestination,
				account_id: acceptDifferenceDestination === 'account' ? acceptDifferenceAccountId : null,
				employee_id: acceptDifferenceDestination === 'employee_debt' ? acceptDifferenceEmployeeId : null,
			}
		} else if (surplusAmount > 0) {
			differencePayload = {
				amount: surplusAmount,
				type: 'surplus',
				destination: 'account',
				account_id: acceptDifferenceAccountId,
				employee_id: null,
			}
		}

		const cashPaymentAccount = acceptPayments.find((item) =>
			Number(item.payment_type_category_id) === 1 && item.account_id
		)?.account_id || null
		const terminalPaymentAccount = acceptPayments.find((item) => {
			const categoryId = Number(item.payment_type_category_id)
			return (categoryId === 2 || categoryId === 5) && item.account_id
		})?.account_id || null

		const payload = {
			id: selectedItem.id,
			cash_amount: totals.cashToAccount,
			bank_amount: totals.bankToAccount,
			note: acceptNote || null,
			account_cash_id: cashPaymentAccount,
			account_terminal_id: terminalPaymentAccount,
			expense_cash_amount: expenseCashAmount,
			expense_cash_account_id: acceptExpenseCashAccountId,
			expense_terminal_amount: expenseTerminalAmount,
			expense_terminal_account_id: acceptExpenseTerminalAccountId,
			income_cash_amount: incomeCashAmount,
			income_cash_account_id: acceptIncomeCashAccountId,
			income_terminal_amount: incomeTerminalAmount,
			income_terminal_account_id: acceptIncomeTerminalAccountId,
			payments: acceptPayments.map((item) => ({
				...item,
				amount: Number(item.amount) || 0,
				system_amount: Number(item.system_amount) || 0,
				income_amount: Number(item.income_amount) || 0,
				expense_amount: Number(item.expense_amount) || 0,
				account_id: item.account_id || null,
			})),
			difference: differencePayload,
		}

		setAcceptLoading(true)
		const response = await POST('/shift-accept', payload, { loader: true })
		setAcceptLoading(false)

		if (httpOk(response)) {
			setShowAcceptModal(false)
			setShowModal(false)
			searchWithFilter()
		}
	}

	function resetFilter() {
		const nextFilterData = {
			start_date: businessMonthStart(),
			end_date: businessToday(),
			status: null,
			size: filterData.size || 20,
			page: 0,
		}
		setFilterData(nextFilterData)
		setFilterDataExist(false)
		searchWithFilter(nextFilterData)
	}

	async function checkFilter() {
		if (
			filterData.start_date === null &&
			filterData.end_date === null
		) {
			setFilterDataExist(false)
		}
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	function handlePaginate(page) {
		const nextFilterData = { ...filterData, page }
		setFilterData(nextFilterData)
		searchWithFilter(nextFilterData)
	}

	function handleApplyFilter() {
		const nextFilterData = { ...filterData, page: 0 }
		setFilterData(nextFilterData)
		searchWithFilter(nextFilterData)
	}

	function handlePageSizeChange(size) {
		const nextFilterData = { ...filterData, size, page: 0 }
		setFilterData(nextFilterData)
		searchWithFilter(nextFilterData)
	}

	function returnEntityType(item) {
		var name = ''
		if (item?.counterparty === 'supplier') {
			name = t('supplier')
		}
		if (item?.counterparty === 'employee' || item?.counterparty === 'employee_salary') {
			name = t('employee')
		}
		if (item?.counterparty === 'organization') {
			name = t('organization')
		}
		if (item?.counterparty === 'client') {
			name = t('client')
		}

		return name
	}

	function TreeTable({ data, level = 0, formatMoney }) {
		return (
			<>
				{data?.map((item, index) => (
					<Fragment key={item.product_id}>
						<tr>
							<td className="text-center">
								{!item.parent_id &&
									<span>{index + 1}</span>
								}
							</td>
							<td style={{ 'paddingLeft': `${level * 10 + 10}px` }}
								onClick={(e) => {
									e.stopPropagation(); // Остановить всплытие события клика
									toggleExpand(item.product_id); // Переключить состояние "открыт/закрыт"
								}}>
								{!item.parent_id &&
									<span className={item?.children?.length ? `product-parent` : ''}>{item.name}</span>
								}
								{item.parent_id &&
									<i className={item?.children?.length ? `product-parent` : ''}>{item.name}</i>
								}
							</td>
							<td>{item.category_name}</td>
							<td>{item.unit_name}</td>
							<td className="text-end">{formatMoney(item.total_quantity, 2)}</td>
						</tr>

						{/* Рекурсивный вызов для children */}
						{expandedItems[item.product_id] && item.children && item.children.length > 0 && (
							<TreeTable
								data={item.children}
								level={level + 1}
								formatMoney={formatMoney}
							/>
						)}
					</Fragment>
				))}
			</>
		);
	}

	const toggleExpand = (product_id) => {
		setExpandedItems((prev) => ({
			...prev,
			[product_id]: !prev[product_id], // Переключаем состояние для текущего элемента
		}));
	};

	useEffect(() => {
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('shifts')} [{data.total}]
				</h4>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex justify-content-between mb-3">
						<div className="d-flex gap-2">
							<div>
								<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
										{t('filter')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											<div className="form-group col-md-12">
												<label>{t('period')}</label>
												<PeriodPicker
													startDate={filterData.start_date}
													endDate={filterData.end_date}
													onChange={(period) => setFilterData({ ...filterData, ...period })}
													withTime={false}
													minDate={new Date(new Date().getFullYear() - 1, 0, 1)}
													maxDate={new Date(new Date().getFullYear(), 11, 31)}
												/>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-12">
												<label>{t('status')}</label>
												<Select
													isClearable
													options={shiftStatuses}
													value={shiftStatuses.find(option => option.id === filterData.status) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'status': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end gap-2">
													<button className="btn btn-secondary" onClick={() => setDropdownIsOpen(false)}>{t('cancel')}</button>
													<button className="btn btn-primary" onClick={() => handleApplyFilter()}>{t('apply')}</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
							<div>
								<button type="button" className="btn btn-outline-primary btn-wide-2"
									onClick={() => searchWithFilter(true)} title={t('EXCEL')}>
									<i className="uil uil-file-download-alt"></i>
								</button>
							</div>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{(filterData.start_date || filterData.end_date) &&
									<span className="me-2">
										<b>{t('period')}: </b>
										{filterData.start_date &&
											<span>{formatDate(filterData.start_date)}</span>
										}
										{(filterData.start_date && filterData.end_date) &&
											<span>|</span>
										}
										{filterData.end_date &&
											<span>{formatDate(filterData.end_date)}</span>
										}
									</span>
								}
								{filterData.status &&
									<span className="me-2">
										<b>{t('status')}: </b>
										{findKeyFromArrayByValue(shiftStatuses, 'id', filterData.status, 'name')}
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase" onClick={resetFilter}>{t('reset')}</button>
							</div>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '100px' }}>ID</th>
									<th style={{ 'width': '15%' }}>{t('cashier')}</th>
									<th style={{ 'width': '12%' }} className="text-center">{t('status')}</th>
									<th style={{ 'minWidth': '115px' }} className="text-center td-ellipsis">{t('open_date')}</th>
									<th style={{ 'minWidth': '115px' }} className="text-center td-ellipsis">{t('close_date')}</th>
									<th className="text-end td-ellipsis">{t('sales')}</th>
									<th className="text-end td-ellipsis">{t('incomes')}</th>
									<th className="text-end td-ellipsis">{t('expenses')}</th>
									<th style={{ 'width': '15%' }} className="text-end">
										<CustomTooltip text={t(`${t('cashbox_balance')} = ${t('cash')} - ${t('expenses')} (${t('terminal')} ${t('separately')})`)}>
											{t('cashbox_balance')}
										</CustomTooltip>
									</th>
									<th style={{ 'width': '40px' }} className="text-center"></th>
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr key={index} className="bg-on-hover"
										onClick={() => toggleModalXreport(item)}>
										<td className="py-1">{item.id}</td>
										<td className="td-ellipsis py-1">{item.cashier_name}</td>
										<td className={`text-center text-nowrap py-1 ${!item.closed_at
											? 'bg-success text-white'
											: isShiftAccepted(item)
												? 'bg-info text-white'
												: 'bg-danger text-white'
											}`}>
											{!item.closed_at &&
												<span>{t('open')}</span>
											}
											{item.closed_at && isShiftAccepted(item) &&
												<span className="d-inline-flex align-items-center gap-1">
													{t('cashbox_accepted')}
													<i className="uil uil-check-circle"
														style={{ 'fontSize': '16px', 'lineHeight': 1, 'marginTop': '-2px' }}>
													</i>
												</span>
											}
											{item.closed_at && !isShiftAccepted(item) &&
												<span>{t('cashbox_not_accepted')}</span>
											}
										</td>
										<td className="text-center py-1">{formatDate(item.opened_at, 'dd.MM.yy HH:mm')}</td>
										<td className="text-center py-1">{formatDate(item.closed_at, 'dd.MM.yy HH:mm')}</td>
										<td className="text-end py-1">{formatMoney(item.total_sales)}</td>
										<td className="text-end py-1 text-success">{Number(item.total_income) ? formatMoney(item.total_income) : '—'}</td>
										<td className="text-end py-1 text-danger">{Number(item.total_expense) ? formatMoney(item.total_expense) : '—'}</td>
										<td className="text-end py-1">{formatMoney(item.balance)}</td>
										<td className="text-center py-1" onClick={(e) => e.stopPropagation()}>
											{canAcceptShift(item) &&
												<div className="d-flex justify-content-center gap-1">
													<div
														title={t('accept_cashbox')}
														onClick={(e) => openAcceptModal(item, e)}>
														<div className="table-action-button table-action-primary-button">
															<i className="uil-check"></i>
														</div>
													</div>
													<div
														title={`${t('expense')} / ${t('income2')}`}
														onClick={(e) => openShiftExpenseIncomeModal(item, e)}>
														<div className="table-action-button table-action-primary-button">
															<i className="uil-plus"></i>
														</div>
													</div>
												</div>
											}
											{isShiftAccepted(item) &&
												<div className="d-flex justify-content-center"
													title={t('preview')}
													onClick={(e) => openAcceptanceViewModal(item, e)}>
													<div className="table-action-button table-action-primary-button">
														<i className="uil-eye"></i>
													</div>
												</div>
											}
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination
							pagination={pagination}
							paginate={handlePaginate}
							showPageSizeSelect
							pageSizeOptions={PAGE_SIZES}
							onPageSizeChange={handlePageSizeChange}>
						</FilterPagination>
					}
				</div>
			</div>

			{/* MODAL */}
			<Modal show={showModal} animation={false} centered
				size="lg"
				onHide={() => setShowModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('additional_info')}</Modal.Title>
				</Modal.Header>
				<Modal.Body style={{ 'maxHeight': 'calc(100vh - 140px)', 'overflow': 'hidden', 'paddingTop': '0.75rem', 'paddingBottom': '0.75rem' }}>
					<div className="d-flex gap-3" style={{ 'height': 'calc(100vh - 180px)', 'minHeight': '320px' }}>
						<div className="no-scroll"
							style={{
								'width': '30%',
								'overflowY': 'auto',
								'lineHeight': '1.35',
								'scrollbarWidth': 'none',
								'msOverflowStyle': 'none',
							}}>
							<div className="right">
								{reports.map((item, index) => (
									<div key={index}>
										<div className="d-flex justify-content-between align-items-center gap-1"
											style={{
												'paddingTop': '4px',
												'paddingBottom': '4px',
												...(activeTab === item.value ? { 'borderBottom': '1px solid #000' } : {}),
											}}>
											<h6 className="mb-0 flex-grow-1"
												style={{ 'cursor': 'pointer', 'fontSize': '14px', 'lineHeight': '1.35' }}
												onClick={() => getData(item.value)}>
												{item.name}
											</h6>
											<div className="d-flex align-items-center gap-1" style={{ 'flexShrink': 0 }}>
												<i className="uil uil-file-download-alt text-success"
													style={{ 'cursor': 'pointer', 'fontSize': '16px' }}
													title={t('EXCEL')}
													onClick={(e) => exportTabExcel(item.value, e)}>
												</i>
												<i className="uil uil-print"
													style={{ 'cursor': 'pointer' }}
													title={t('print')}
													onClick={(e) => printTabReport(item.value, e)}>
												</i>
											</div>
										</div>
										{item.value === 'cashiers_x' && activeTab === 'cashiers_x' &&
											<div className="ms-2 mb-2">
												{getCashiersXList().map((cashier, cIndex) => (
													<div
														key={cashier.cashier_login ?? cIndex}
														className="d-flex justify-content-between align-items-center px-2"
														style={{
															'cursor': 'pointer',
															'lineHeight': '1.35',
															'fontSize': '13px',
															'paddingTop': '4px',
															'paddingBottom': '4px',
															...(activeCashierLogin === cashier.cashier_login
																? { 'borderBottom': '1px solid #000' }
																: {}),
														}}
														onClick={() => setActiveCashierLogin(cashier.cashier_login)}
													>
														<div className="d-flex align-items-center gap-2">
															<span>{activeCashierLogin === cashier.cashier_login ? '▾' : '▸'}</span>
															<span>{cashier.cashier_name}</span>
														</div>
														<i className="uil-print"
															style={{ 'cursor': 'pointer', 'flexShrink': 0 }}
															title={t('print')}
															onClick={(e) => {
																e.stopPropagation()
																setActiveCashierLogin(cashier.cashier_login)
																setTimeout(() => handlePrint(), 350)
															}}>
														</i>
													</div>
												))}
											</div>
										}
									</div>
								))}
							</div>
						</div>
						<div id="print" ref={printRef} className="shift-thermal-print no-scroll"
							style={{
								'width': '70%',
								'lineHeight': '16px',
								'overflowY': 'auto',
								'scrollbarWidth': 'none',
								'msOverflowStyle': 'none',
							}}>
							{activeTab === 'x_report' &&
								<div>
									<div className="d-flex justify-content-between mb-1">
										<span>{t('pos')}</span>
										<span>{xReportData.x_report.pos_name}</span>
									</div>
									<div className="d-flex justify-content-between mb-1">
										<span>{t('cashbox')}</span>
										<span>{xReportData.x_report.cashbox_name}</span>
									</div>
									<div className="d-flex justify-content-between mb-1">
										<span>{t('shift')} ID</span>
										<span>{xReportData.x_report.shift_id}</span>
									</div>
									<div className="d-flex justify-content-between mb-1">
										<span>{t('shift_number')}</span>
										<span>{xReportData.x_report.shift_number}</span>
									</div>
									<div className="d-flex justify-content-between mb-1">
										<span>{t('cashier')}</span>
										<span>{xReportData.x_report.cashier_name}</span>
									</div>
									<div className="d-flex justify-content-between mb-1">
										<span>{t('start_of_shift')}</span>
										<span>{formatDate(xReportData.x_report.opened_at, 'dd.MM.yy HH:mm')}</span>
									</div>
									<div className="d-flex justify-content-between mb-1">
										<span>{t('end_of_shift')}</span>
										<span>{formatDate(xReportData.x_report.closed_at, 'dd.MM.yy HH:mm')}</span>
									</div>
									<hr />
									<div className="d-flex justify-content-between mb-1">
										<span>{t('number_of_checks')} [ {t('hall')} ]</span>
										<span>{xReportData.x_report.count_hall}</span>
									</div>
									<div className="d-flex justify-content-between mb-1">
										<span>{t('number_of_checks')} [ {t('takeaway')} ]</span>
										<span>{xReportData.x_report.count_takeaway}</span>
									</div>
									<div className="d-flex justify-content-between mb-1">
										<span>{t('number_of_checks')} [ {t('delivery')} ]</span>
										<span>{xReportData.x_report.count_delivery}</span>
									</div>
									<div className="d-flex justify-content-between mb-1">
										<b>{t('number_of_checks')}</b>
										<b>{xReportData.x_report.count_cheques}</b>
									</div>
									{!!xReportData.x_report.count_deleted_cheques &&
										<>
											<div className="d-flex justify-content-between">
												<p>{t('deleted_cheques')}</p>
												<p>{xReportData.x_report.count_deleted_cheques}</p>
											</div>
											<div className="d-flex justify-content-between">
												<p>{t('deleted_products')}</p>
												<p>{formatMoney(xReportData.x_report.count_deleted_products)}</p>
											</div>
										</>
									}
									{(xReportData && xReportData.x_report?.payments?.length > 0) &&
										<hr />
									}
									<div className="d-flex justify-content-between fz14">
										<span>{t('sales')}</span>
										<span className="text-success">{formatMoney(xReportData.x_report?.sales)}</span>
									</div>
									<div className="d-flex justify-content-between fz14">
										<span>{t('service')}</span>
										<span className="text-success">{formatMoney(xReportData.x_report?.service_percentage_amount)}</span>
									</div>
									<div className="d-flex justify-content-between fz14">
										<span>{t('delivery')}</span>
										<span className="text-success">{formatMoney(xReportData.x_report?.total_delivery_amount)}</span>
									</div>
									<div className="d-flex justify-content-between fz14">
										<b>{t('sales_amount')}</b>
										<b>{formatMoney(xReportData.x_report?.total_sales)}</b>
									</div>
									<div className="ms-2">
										<div className="d-flex justify-content-between d-none">
											<p>{t('change')}</p>
											<p className="text-success">{formatMoney(xReportData.x_report?.total_change)}</p>
										</div>
										<div className="d-flex justify-content-between">
											<p>{t('discount')}</p>
											<p className="text-danger">{formatMoney(xReportData.x_report?.total_discount)}</p>
										</div>
										<div className="d-flex justify-content-between">
											<span>{t('debt')}</span>
											<span className="text-danger">{formatMoney(xReportData.x_report.total_debt_amount)}</span>
										</div>
										{xReportData.x_report.loyalty &&
											<div className="d-flex justify-content-between">
												<span>{t('loyalty')}</span>
												<span className="text-danger">{formatMoney(xReportData.x_report?.loyalty)}</span>
											</div>
										}
										<div className="d-flex justify-content-between">
											<b>
												<CustomTooltip text={t(`${t('total')} = ${t('discount')} + ${t('debt')} + ${t('shortage')} + ${t('agents_bonus')}`)}>
													{t('total')}
												</CustomTooltip>
											</b>
											<b className="text-danger">
												{formatMoney(
													Number(xReportData.x_report.total_discount) +
													Number(xReportData.x_report.total_debt_amount)
												)}
											</b>
										</div>
									</div>
									<div className="d-flex justify-content-between fz14">
										<b>
											<CustomTooltip text={t(`${t('total_checkout')} = ${t('sales_amount')} - ${t('discount')} - ${t('sold_on_credit')} + ${t('amortization')}`)}>
												{t('total_checkout')}
											</CustomTooltip>
										</b>
										<b>{formatMoney(xReportData.x_report?.total_payments)}</b>
									</div>
									<div className="ms-2">
										{xReportData.x_report?.payments?.map((item, index) => (
											<div className="d-flex justify-content-between py-1" key={index}
												style={{ 'borderBottom': '1px solid var(--dark-border, #eee)' }}>
												<p className="d-flex flex-wrap gap-1 mb-0">
													{item.transaction_type === 'plus' ?
														<span>&#9660;</span>
														:
														<span>&#9650;</span>
													}
													<span>{item.payment_type_name}</span>
													<span>{item.payment_purpose_name}</span>
												</p>
												{item.transaction_type === 'plus' ?
													<p className="text-success text-nowrap mb-0">{formatMoney(item.amount)}</p>
													:
													<p className="text-danger text-nowrap mb-0">{formatMoney(item.amount)}</p>
												}
											</div>
										))}
										{!!xReportData.x_report.total_cash &&
											<div className="d-flex justify-content-between">
												<b>{t('total_cash')}</b>
												<b className="text-success">
													{formatMoney(xReportData.x_report.total_cash)}
												</b>
											</div>
										}
										{!!xReportData.x_report.total_bank &&
											<div className="d-flex justify-content-between">
												<b>{t('total_bank')}</b>
												<b className="text-success">
													{formatMoney(xReportData.x_report.total_bank)}
												</b>
											</div>
										}
										{!!xReportData.x_report.total_expense &&
											<div className="d-flex justify-content-between">
												<b>{t('total_expense')}</b>
												<b className="text-danger">
													{formatMoney(xReportData.x_report.total_expense)}
												</b>
											</div>
										}
									</div>
									<hr />
									<b className="d-flex justify-content-between">
										<h5 className="color-00">
											<CustomTooltip text={t(`${t('cashbox_balance')} = ${t('cash')} - ${t('expenses')} (${t('terminal')} ${t('separately')})`)}>
												{t('cashbox_balance')}
											</CustomTooltip>
										</h5>
										<h5 className="text-no-wrap color-00">
											{formatMoney(xReportData.x_report.balance)}
										</h5>
									</b>
								</div>
							}
							{activeTab === 'menus' &&
								<div style={{ 'height': '100%', 'overflow': 'auto' }}>
									<table className="table table-bordered table-bordered-custom">
										<thead>
											<tr>
												<th className="text-start"><b>{t('menu')}</b></th>
												<th className="text-end"><b>{t('quantity')}</b></th>
												<th className="text-end"><b>{t('amount')}</b></th>
											</tr>
										</thead>
										<tbody>
											{renderMenuTreeRows(xReportData?.menus?.data)}
										</tbody>
										<tfoot>
											<tr>
												<td><b>{t('total')}</b></td>
												<td className="text-end text-nowrap">
													<b>{formatMoney(xReportData.menus.total_quantity)}</b>
												</td>
												<td className="text-end text-nowrap">
													<b>{formatMoney(xReportData.menus.total_amount)}</b>
												</td>
											</tr>
										</tfoot>
									</table>
								</div>
							}
							{activeTab === 'products' &&
								<div style={{ 'height': '100%', 'overflow': 'auto' }}>
									<table className="table table-bordered table-bordered-custom">
										<thead>
											<tr>
												<th className="text-start"><b>{t('menu')}</b></th>
												<th className="text-start"><b>{t('product')}</b></th>
												<th className="text-end text-nowrap"><b>{t('quantity')}</b></th>
												<th className="text-end text-nowrap"><b>{t('amount')}</b></th>
											</tr>
										</thead>
										<tbody>
											{xReportData?.products?.data?.map((item, index) => (
												<tr key={index}>
													<td className="text-start">{item.menu_name}</td>
													<td className="text-start">{item.name}</td>
													<td className="text-end text-nowrap">{formatMoney(item.total_quantity, 2)}</td>
													<td className="text-end text-nowrap">{formatMoney(item.total_amount)}</td>
												</tr>
											))}
										</tbody>
										<tfoot>
											<tr>
												<td><b>{t('total')}</b></td>
												<td></td>
												<td className="text-end text-nowrap">
													<b>{formatMoney(xReportData.products.total_quantity, 2)}</b>
												</td>
												<td className="text-end text-nowrap">
													<b>{formatMoney(xReportData.products.total_amount)}</b>
												</td>
											</tr>
										</tfoot>
									</table>
								</div>
							}
							{activeTab === 'preparation_places' &&
								<div style={{ 'height': '100%', 'overflow': 'auto' }}>
									<table className="table table-bordered table-bordered-custom">
										<thead>
											<tr>
												<th className="text-start"><b>{t('preparation_places')}</b></th>
												<th className="text-end"><b>{t('quantity')}</b></th>
												<th className="text-end"><b>{t('amount')}</b></th>
											</tr>
										</thead>
										<tbody>
											{xReportData?.preparation_places?.data?.map((item, index) => (
												<tr key={index}>
													<td className="text-start">{item.name}</td>
													<td className="text-end">{formatMoney(item.total_quantity)}</td>
													<td className="text-end">{formatMoney(item.total_amount)}</td>
												</tr>
											))}
										</tbody>
										<tfoot>
											<tr>
												<td><b>{t('total')}</b></td>
												<td className="text-end">
													<b>{formatMoney(xReportData.preparation_places.total_quantity)}</b>
												</td>
												<td className="text-end">
													<b>{formatMoney(xReportData.preparation_places.total_amount)}</b>
												</td>
											</tr>
										</tfoot>
									</table>
								</div>
							}
							{activeTab === 'deleted_cheques' &&
								<div style={{ 'height': '100%', 'overflow': 'auto' }}>
									<div className="table-responsive" >
										<table className="table table-bordered table-bordered-custom">
											<thead>
												<tr>
													<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
													<th className="text-start"
														style={{ 'width': '25%' }}>
														<b>{t('cashier')}</b>
													</th>
													<th className="text-start"
														style={{ 'width': '25%' }}>
														<b>{t('waiter')}</b>
													</th>
													<th className="text-center"
														style={{ 'width': '20%' }}><b>{t('time')}</b>
													</th>
													<th className="text-end"
														style={{ 'width': '10%' }}>
														<b>№</b>
													</th>
													<th className="text-end"
														style={{ 'width': '20%' }}>
														<b>{t('amount')}</b>
													</th>
												</tr>
											</thead>
											<tbody>
												{xReportData['deleted_cheques']?.data?.map((item, index) => (
													<tr key={index}
														onClick={() => toggleRightbar(true, item)}>
														<td className="text-center">{index + 1}</td>
														<td className="text-start td-ellipsis">
															{item.cashier_name}
														</td>
														<td className="text-start td-ellipsis">
															{item.waiter_name}
														</td>
														<td className="text-center">
															{formatDate(item.cheque_closed_at, 'HH:mm')}
														</td>
														<td className="text-end td-ellipsis">
															{item.cheque_number}
														</td>
														<td className="text-end td-ellipsis">
															{formatMoney(item.total_amount)}
														</td>
													</tr>
												))}
											</tbody>
											<tfoot>
												<tr>
													<td></td>
													<td><b>{t('total')}</b></td>
													<td></td>
													<td></td>
													<td></td>
													<td className="text-end">
														<b>{formatMoney(xReportData.deleted_cheques.total_amount)}</b>
													</td>
												</tr>
											</tfoot>
										</table>
									</div>
								</div>
							}
							{activeTab === 'discount_cheques' &&
								<div style={{ 'height': '100%', 'overflow': 'auto' }}>
									<div className="table-responsive" >
										<table className="table table-bordered table-bordered-custom">
											<thead>
												<tr>
													<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
													<th className="text-start"
														style={{ 'width': '25%' }}>
														<b>{t('cashier')}</b>
													</th>
													<th className="text-start"
														style={{ 'width': '25%' }}>
														<b>{t('waiter')}</b>
													</th>
													<th className="text-center"
														style={{ 'width': '15%' }}><b>{t('time')}</b>
													</th>
													<th className="text-end"
														style={{ 'width': '10%' }}>
														<b>№</b>
													</th>
													<th className="text-end"
														style={{ 'width': '12%' }}>
														<b>{t('discount')}</b>
													</th>
													<th className="text-end"
														style={{ 'width': '13%' }}>
														<b>{t('amount')}</b>
													</th>
												</tr>
											</thead>
											<tbody>
												{xReportData['discount_cheques']?.data?.map((item, index) => (
													<tr key={index}
														style={{ 'cursor': 'pointer' }}
														onClick={() => toggleRightbar(true, item)}>
														<td className="text-center">{index + 1}</td>
														<td className="text-start td-ellipsis">
															{item.cashier_name}
														</td>
														<td className="text-start td-ellipsis">
															{item.waiter_name}
														</td>
														<td className="text-center">
															{formatDate(item.cheque_closed_at, 'HH:mm')}
														</td>
														<td className="text-end td-ellipsis">
															{item.cheque_number}
														</td>
														<td className="text-end td-ellipsis text-danger">
															{formatMoney(item.discount)}
														</td>
														<td className="text-end td-ellipsis">
															{formatMoney(item.total_amount)}
														</td>
													</tr>
												))}
											</tbody>
											<tfoot>
												<tr>
													<td></td>
													<td><b>{t('total')}</b></td>
													<td></td>
													<td></td>
													<td></td>
													<td className="text-end text-danger">
														<b>{formatMoney(xReportData.discount_cheques?.total_discount)}</b>
													</td>
													<td className="text-end">
														<b>{formatMoney(xReportData.discount_cheques?.total_amount)}</b>
													</td>
												</tr>
											</tfoot>
										</table>
									</div>
								</div>
							}
							{activeTab === 'deleted_products' &&
								<div style={{ 'height': '100%', 'overflow': 'auto' }}>
									<div className="table-responsive" >
										<table className="table table-bordered table-bordered-custom">
											<thead>
												<tr>
													<th className="text-start"
														style={{ 'width': '30%' }}>
														<b>{t('name2')}</b>
													</th>
													<th className="text-center"
														style={{ 'width': '20%' }}><b>{t('time')}</b>
													</th>
													<th className="text-end"
														style={{ 'width': '10%' }}>
														<b>№</b>
													</th>
													<th className="text-end text-nowrap"
														style={{ 'width': '20%' }}>
														<b>{t('quantity')}</b>
													</th>
													<th className="text-end"
														style={{ 'width': '20%' }}>
														<b>{t('amount')}</b>
													</th>
												</tr>
											</thead>
											<tbody>
												{xReportData['deleted_products']?.data?.map((item, index) => (
													<tr key={index}
														onClick={() => toggleRightbar(true, item)}>
														<td className="text-start td-ellipsis">
															{item.name}
														</td>
														<td className="text-center">
															{formatDate(item.created_at, 'HH:mm')}
														</td>
														<td className="text-end td-ellipsis">
															{item.cheque_number}
														</td>
														<td className="text-end td-ellipsis">
															{item.quantity}
														</td>
														<td className="text-end td-ellipsis">
															{formatMoney(item.total_price)}
														</td>
													</tr>
												))}
											</tbody>
											<tfoot>
												<tr>
													<td><b>{t('total')}</b></td>
													<td></td>
													<td></td>
													<td className="text-end">
														<b>{formatMoney(xReportData.deleted_products.total_quantity)}</b>
													</td>
													<td className="text-end">
														<b>{formatMoney(xReportData.deleted_products.total_amount)}</b>
													</td>
												</tr>
											</tfoot>
										</table>
									</div>
								</div>
							}
							{activeTab === 'order_types' &&
								<div style={{ 'height': '100%', 'overflow': 'auto' }}>
									<table className="table table-bordered table-bordered-custom">
										<thead>
											<tr>
												<th className="text-start"><b>{t('order_type')}</b></th>
												<th className="text-end"><b>{t('quantity')}</b></th>
												<th className="text-end"><b>{t('amount')}</b></th>
											</tr>
										</thead>
										<tbody>
											{xReportData.order_types?.data?.map((item, index) => (
												<tr key={index}>
													<td className="text-start">{item.name}</td>
													<td className="text-end">{formatMoney(item.total_quantity)}</td>
													<td className="text-end">{formatMoney(item.total_amount)}</td>
												</tr>
											))}
										</tbody>
										<tfoot>
											<tr>
												<td><b>{t('total')}</b></td>
												<td className="text-end text-nowrap">
													<b>{formatMoney(xReportData.order_types.total_quantity)}</b>
												</td>
												<td className="text-end text-nowrap">
													<b>{formatMoney(xReportData.order_types.total_amount)}</b>
												</td>
											</tr>
										</tfoot>
									</table>
								</div>
							}
							{activeTab === 'order_sub_types' &&
								<div style={{ 'height': '100%', 'overflow': 'auto' }}>
									<table className="table table-bordered table-bordered-custom">
										<thead>
											<tr>
												<th className="text-start"><b>{t('delivery_type')}</b></th>
												<th className="text-end"><b>{t('quantity')}</b></th>
												<th className="text-end"><b>{t('amount')}</b></th>
											</tr>
										</thead>
										<tbody>
											{xReportData.order_sub_types?.data?.map((item, index) => (
												<tr key={index}>
													<td className="text-start">{item.name}</td>
													<td className="text-end">{formatMoney(item.total_quantity)}</td>
													<td className="text-end">{formatMoney(item.total_amount)}</td>
												</tr>
											))}
										</tbody>
										<tfoot>
											<tr>
												<td><b>{t('total')}</b></td>
												<td className="text-end">
													<b>{formatMoney(xReportData?.order_sub_types?.total_quantity)}</b>
												</td>
												<td className="text-end">
													<b>{formatMoney(xReportData?.order_sub_types?.total_amount)}</b>
												</td>
											</tr>
										</tfoot>
									</table>
								</div>
							}
							{activeTab === 'payment_types' &&
								<div style={{ 'height': '100%', 'overflow': 'auto' }}>
									<table className="table table-bordered table-bordered-custom">
										<thead>
											<tr>
												<th className="text-start"><b>{t('name2')}</b></th>
												<th className="text-end"><b>{t('quantity')}</b></th>
												<th className="text-end"><b>{t('amount')}</b></th>
											</tr>
										</thead>
										<tbody>
											{xReportData.payment_types?.data?.map((item, index) => (
												<tr key={index}>
													<td className="text-start">{item.name}</td>
													<td className="text-end">{formatMoney(item.total_quantity)}</td>
													<td className="text-end">{formatMoney(item.total_amount)}</td>
												</tr>
											))}
										</tbody>
										<tfoot>
											<tr>
												<td><b>{t('total')}</b></td>
												<td className="text-end">
													<b>{formatMoney(xReportData?.payment_types?.total_quantity)}</b>
												</td>
												<td className="text-end">
													<b>{formatMoney(xReportData?.payment_types?.total_amount)}</b>
												</td>
											</tr>
										</tfoot>
									</table>
								</div>
							}
							{activeTab === 'expenses' &&
								<div style={{ 'height': '100%', 'overflow': 'auto' }}>
									<table className="table table-bordered table-bordered-custom">
										<thead>
											<tr>
												<th className="text-start"
													style={{ 'width': '40%' }}><b>{t('type')}</b>
												</th>
												<th className="text-start"
													style={{ 'width': '20%' }}><b>{t('counterparty')}</b>
												</th>
												<th className="text-start"
													style={{ 'width': '20%' }}><b>{t('note')}</b>
												</th>
												<th className="text-end"
													style={{ 'width': '20%' }}><b>{t('amount')}</b>
												</th>
											</tr>
										</thead>
										<tbody>
											{xReportData['expenses']?.data?.map((item, index) => (
												<tr key={index}>
													<td className="text-start td-ellipsis">
														{item.name}
													</td>
													<td className="text-start td-ellipsis" title={item.counterparty}>
														{item.counterparty}
													</td>
													<td className="text-start td-ellipsis" title={item.note}>
														{item.note}
													</td>
													<td className="text-end text-nowrap">
														{formatMoney(item.amount)}
													</td>
												</tr>
											))}
										</tbody>
										<tfoot>
											<tr>
												<td><b>{t('total')}</b></td>
												<td></td>
												<td></td>
												<td className="text-end text-nowrap">
													<b>{formatMoney(xReportData.expenses.total_amount)}</b>
												</td>
											</tr>
										</tfoot>
									</table>
								</div>
							}
							{activeTab === 'incomes' &&
								<div style={{ 'height': '100%', 'overflow': 'auto' }}>
									<table className="table table-bordered table-bordered-custom">
										<thead>
											<tr>
												<th className="text-start"
													style={{ 'width': '50%' }}><b>{t('type')}</b></th>
												<th className="text-start"
													style={{ 'width': '30%' }}><b>{t('counterparty')}</b></th>
												<th className="text-end"
													style={{ 'width': '20%' }}><b>{t('amount')}</b></th>
											</tr>
										</thead>
										<tbody>
											{xReportData['incomes']?.data?.map((item, index) => (
												<tr key={index}>
													<td className="text-start td-ellipsis">
														{item.name}
													</td>
													<td className="text-start td-ellipsis">
														{item.counterparty}
													</td>
													<td className="text-end">
														{formatMoney(item.amount)}
													</td>
												</tr>
											))}
										</tbody>
										<tfoot>
											<tr>
												<td><b>{t('total')}</b></td>
												<td></td>
												<td className="text-end">
													<b>{formatMoney(xReportData.incomes.total_amount)}</b>
												</td>
											</tr>
										</tfoot>
									</table>
								</div>
							}
							{activeTab === 'debtors' &&
								<div style={{ 'height': '100%', 'overflow': 'auto' }}>
									<table className="table table-bordered table-bordered-custom mb-2">
										<thead>
											<tr>
												<th className="text-start"><b>{t('client')}</b></th>
												<th className="text-start"><b>{t('counterparty')}</b></th>
												<th className="text-end"><b>{t('amount')}</b></th>
											</tr>
										</thead>
										<tbody>
											{xReportData['debtors']?.data?.map((item, index) => (
												<tr key={index}>
													<td className="text-start">{item.name}</td>
													<td className="text-start">{returnEntityType(item)}</td>
													<td className="text-end">{formatMoney(item.total_amount)}</td>
												</tr>
											))}
										</tbody>
										<tfoot>
											<tr>
												<td><b>{t('total')}</b></td>
												<td></td>
												<td className="text-end">
													<b>{formatMoney(xReportData.debtors.total_amount)}</b>
												</td>
											</tr>
										</tfoot>
									</table>
								</div>
							}
							{activeTab === 'clients' &&
								<div style={{ 'height': '100%', 'overflow': 'auto' }}>
									<table className="table table-bordered table-bordered-custom">
										<thead>
											<tr>
												<th className="text-start"><b>{t('client')}</b></th>
												<th className="text-end"><b>{t('quantity')}</b></th>
												<th className="text-end"><b>{t('amount')}</b></th>
											</tr>
										</thead>
										<tbody>
											{xReportData?.clients?.data?.map((item, index) => (
												<tr key={index}>
													<td className="text-start">{item.name}</td>
													<td className="text-end">{formatMoney(item.total_quantity)}</td>
													<td className="text-end">{formatMoney(item.total_amount)}</td>
												</tr>
											))}
										</tbody>
										<tfoot>
											<tr>
												<td><b>{t('total')}</b></td>
												<td className="text-end">
													<b>{formatMoney(xReportData.clients.total_quantity)}</b>
												</td>
												<td className="text-end">
													<b>{formatMoney(xReportData.clients.total_amount)}</b>
												</td>
											</tr>
										</tfoot>
									</table>
								</div>
							}
							{activeTab === 'waiters' &&
								<div style={{ 'height': '100%', 'overflow': 'auto' }}>
									<table className="table table-bordered table-bordered-custom">
										<thead>
											<tr>
												<th className="text-start"><b>{t('waiter')}</b></th>
												<th className="text-end"><b>{t('quantity')}</b></th>
												<th className="text-end"><b>{t('service')}</b></th>
												<th className="text-end"><b>{t('amount')}</b></th>
											</tr>
										</thead>
										<tbody>
											{xReportData?.waiters?.data?.map((item, index) => (
												<tr key={index}>
													<td className="text-start">{item.name}</td>
													<td className="text-end">{formatMoney(item.total_quantity)}</td>
													<td className="text-end">{formatMoney(item.total_service_amount)}</td>
													<td className="text-end">{formatMoney(item.total_amount)}</td>
												</tr>
											))}
										</tbody>
										<tfoot>
											<tr>
												<td><b>{t('total')}</b></td>
												<td className="text-end">
													<b>{formatMoney(xReportData.waiters.total_quantity)}</b>
												</td>
												<td className="text-end">
													<b>{formatMoney(xReportData.waiters.total_service_amount)}</b>
												</td>
												<td className="text-end">
													<b>{formatMoney(xReportData.waiters.total_amount)}</b>
												</td>
											</tr>
										</tfoot>
									</table>
								</div>
							}
							{activeTab === 'waiter_menus' &&
								<div style={{ 'height': '100%', 'overflow': 'auto' }}>
									{xReportData?.waiter_menus?.data?.map((waiter, wIndex) => (
										<div className="mb-3" key={wIndex}>
											<table className="table table-bordered table-bordered-custom">
												<thead>
													<tr>
														<th style={{ 'width': '50%' }} className="text-start"><b>{waiter.name}</b></th>
														<th style={{ 'width': '25%' }} className="text-end text-nowrap"><b>{t('quantity')}</b></th>
														<th style={{ 'width': '25%' }} className="text-end text-nowrap"><b>{t('amount')}</b></th>
													</tr>
												</thead>
												<tbody>
													{renderMenuTreeRows(waiter?.groups, 2)}
												</tbody>
												<tfoot>
													<tr>
														<td><b>{t('total')}</b></td>
														<td className="text-end text-nowrap">
															<b>{formatMoney(waiter.total_quantity, 2)}</b>
														</td>
														<td className="text-end text-nowrap">
															<b>{formatMoney(waiter.total_amount)}</b>
														</td>
													</tr>
												</tfoot>
											</table>
										</div>
									))}
								</div>
							}
							{activeTab === 'waiter_products' &&
								<div style={{ 'height': '100%', 'overflow': 'auto' }}>
									{xReportData?.waiter_products?.data?.map((waiter, wIndex) => (
										<div className="mb-3" key={wIndex}>
											<table className="table table-bordered table-bordered-custom">
												<thead>
													<tr>
														<th style={{ 'width': '50%' }} className="text-start"><b>{waiter.name}</b></th>
														<th style={{ 'width': '25%' }} className="text-end text-nowrap"><b>{t('quantity')}</b></th>
														<th style={{ 'width': '25%' }} className="text-end text-nowrap"><b>{t('amount')}</b></th>
													</tr>
												</thead>
												<tbody>
													{waiter?.products?.map((item, index) => (
														<tr key={index}>
															<td className="text-start">{item.name}</td>
															<td className="text-end text-nowrap">{formatMoney(item.total_quantity, 2)}</td>
															<td className="text-end text-nowrap">{formatMoney(item.total_amount)}</td>
														</tr>
													))}
												</tbody>
												<tfoot>
													<tr>
														<td><b>{t('total')}</b></td>
														<td className="text-end text-nowrap">
															<b>{formatMoney(waiter.total_quantity, 2)}</b>
														</td>
														<td className="text-end text-nowrap">
															<b>{formatMoney(waiter.total_amount)}</b>
														</td>
													</tr>
												</tfoot>
											</table>
										</div>
									))}
								</div>
							}
							{activeTab === 'cashiers' &&
								<div style={{ 'height': '100%', 'overflow': 'auto' }}>
									<table className="table table-bordered table-bordered-custom">
										<thead>
											<tr>
												<th className="text-start"><b>{t('cashier')}</b></th>
												<th className="text-end"><b>{t('quantity')}</b></th>
												<th className="text-end"><b>{t('amount')}</b></th>
											</tr>
										</thead>
										<tbody>
											{xReportData?.cashiers?.data?.map((item, index) => (
												<tr key={index}>
													<td className="text-start">{item.name}</td>
													<td className="text-end">{formatMoney(item.total_quantity)}</td>
													<td className="text-end">{formatMoney(item.total_amount)}</td>
												</tr>
											))}
										</tbody>
										<tfoot>
											<tr>
												<td><b>{t('total')}</b></td>
												<td className="text-end">
													<b>{formatMoney(xReportData.cashiers.total_quantity)}</b>
												</td>
												<td className="text-end">
													<b>{formatMoney(xReportData.cashiers.total_amount)}</b>
												</td>
											</tr>
										</tfoot>
									</table>
								</div>
							}
							{activeTab === 'cashiers_x' && getActiveCashierX() &&
								(() => {
									const item = getActiveCashierX()
									return (
										<div className="no-scroll" style={{ 'height': '100%', 'overflow': 'auto' }}>
											<div className="cashier-info-block"
												style={{ 'height': 'auto', 'overflow': 'visible' }}>
												<div className="d-flex justify-content-between mb-1">
													<span>{t('pos')}</span>
													<span>{item.pos_name}</span>
												</div>
												<div className="d-flex justify-content-between mb-1">
													<span>{t('cashbox')}</span>
													<span>{item.cashbox_name}</span>
												</div>
												<div className="d-flex justify-content-between mb-1">
													<span>{t('shift')} ID</span>
													<span>{item.shift_id}</span>
												</div>
												<div className="d-flex justify-content-between mb-1">
													<span>{t('shift_number')}</span>
													<span>{item.shift_number}</span>
												</div>
												<div className="d-flex justify-content-between mb-1">
													<span>{t('cashier')}</span>
													<span>{item.cashier_name}</span>
												</div>
												<div className="d-flex justify-content-between mb-1">
													<span>{t('start_of_shift')}</span>
													<span>{formatDate(item.opened_at, 'dd.MM.yy HH:mm')}</span>
												</div>
												<div className="d-flex justify-content-between mb-1">
													<span>{t('end_of_shift')}</span>
													<span>{formatDate(item.closed_at, 'dd.MM.yy HH:mm')}</span>
												</div>
												<hr />
												<div className="d-flex justify-content-between mb-1">
													<span>{t('number_of_checks')} [ {t('hall')} ]</span>
													<span>{item.count_hall}</span>
												</div>
												<div className="d-flex justify-content-between mb-1">
													<span>{t('number_of_checks')} [ {t('takeaway')} ]</span>
													<span>{item.count_takeaway}</span>
												</div>
												<div className="d-flex justify-content-between mb-1">
													<span>{t('number_of_checks')} [ {t('delivery')} ]</span>
													<span>{item.count_delivery}</span>
												</div>
												<div className="d-flex justify-content-between mb-1">
													<b>{t('number_of_checks')}</b>
													<b>{item.count_cheques}</b>
												</div>
												{!!item.count_deleted_cheques &&
													<>
														<div className="d-flex justify-content-between">
															<p>{t('deleted_cheques')}</p>
															<p>{item.count_deleted_cheques}</p>
														</div>
														<div className="d-flex justify-content-between">
															<p>{t('deleted_products')}</p>
															<p>{item.count_deleted_products}</p>
														</div>
													</>
												}
												{(item && item?.payments?.length > 0) &&
													<hr />
												}
												<div className="d-flex justify-content-between fz14">
													<span>{t('sales')}</span>
													<span className="text-success">{formatMoney(item?.sales)}</span>
												</div>
												<div className="d-flex justify-content-between fz14">
													<span>{t('service')}</span>
													<span className="text-success">{formatMoney(item?.service_percentage_amount)}</span>
												</div>
												<div className="d-flex justify-content-between fz14">
													<span>{t('delivery')}</span>
													<span className="text-success">{formatMoney(item?.total_delivery_amount)}</span>
												</div>
												<div className="d-flex justify-content-between fz14">
													<b>{t('sales_amount')}</b>
													<b>{formatMoney(item?.total_sales)}</b>
												</div>
												<div className="ms-2">
													<div className="d-flex justify-content-between d-none">
														<p>{t('change')}</p>
														<p className="text-success">{formatMoney(item?.total_change)}</p>
													</div>
													<div className="d-flex justify-content-between">
														<p>{t('discount')}</p>
														<p className="text-danger">{formatMoney(item?.total_discount)}</p>
													</div>
													<div className="d-flex justify-content-between">
														<span>{t('debt')}</span>
														<span className="text-danger">{formatMoney(item.total_debt_amount)}</span>
													</div>
													{item.loyalty &&
														<div className="d-flex justify-content-between">
															<span>{t('loyalty')}</span>
															<span>{formatMoney(item?.loyalty?.amount_out)}</span>
														</div>
													}
													<div className="d-flex justify-content-between">
														<b>
															<CustomTooltip text={t(`${t('total')} = ${t('discount')} + ${t('debt')} + ${t('shortage')} + ${t('agents_bonus')}`)}>
																{t('total')}
															</CustomTooltip>
														</b>
														<b className="text-danger">
															{formatMoney(
																Number(item.total_discount) +
																Number(item.total_debt_amount)
															)}
														</b>
													</div>
												</div>
												<div className="d-flex justify-content-between fz14">
													<b>
														<CustomTooltip text={t(`${t('total_checkout')} = ${t('sales_amount')} - ${t('discount')} - ${t('agents_bonus')} - ${t('sold_on_credit')} + ${t('amortization')}`)}>
															{t('total_checkout')}
														</CustomTooltip>
													</b>
													<b>{formatMoney(item?.total_payments)}</b>
												</div>
												<div className="ms-2">
													{item.loyalty &&
														<div className="d-flex justify-content-between">
															<span>{t('loyalty')}</span>
															<span>{formatMoney(item?.loyalty?.amount_in)}</span>
														</div>
													}
													{item?.payments?.map((payment, paymentIndex) => (
														<div key={paymentIndex} className="d-flex justify-content-between bg-hover-gray"
															style={{ 'borderBottom': '1px solid var(--dark-border, #eee)' }}>
															<p className="d-flex flex-wrap gap-1">
																{payment.transaction_type === 'plus' ?
																	<span>&#9660;</span>
																	:
																	<span>&#9650;</span>
																}
																<span>{payment.payment_type_name}</span>
																<span>{payment.payment_purpose_name}</span>
															</p>
															{payment.transaction_type === 'plus' ?
																<p className="text-success text-nowrap">{formatMoney(payment.amount)}</p>
																:
																<p className="text-danger text-nowrap">{formatMoney(payment.amount)}</p>
															}
														</div>
													))}
													{!!item.total_cash &&
														<div className="d-flex justify-content-between">
															<b>{t('total_cash')}</b>
															<b className="text-success">
																{formatMoney(item.total_cash)}
															</b>
														</div>
													}
													{!!item.total_bank &&
														<div className="d-flex justify-content-between">
															<b>{t('total_bank')}</b>
															<b className="text-success">
																{formatMoney(item.total_bank)}
															</b>
														</div>
													}
													{!!item.total_expense &&
														<div className="d-flex justify-content-between">
															<b>{t('total_expense')}</b>
															<b className="text-danger">
																{formatMoney(item.total_expense)}
															</b>
														</div>
													}
												</div>
												<hr />
												<b className="d-flex justify-content-between">
													<h5 className="color-00">
														<CustomTooltip text={t(`${t('cashbox_balance')} = ${t('cash')} - ${t('expenses')} (${t('terminal')} ${t('separately')})`)}>
															{t('cashbox_balance')}
														</CustomTooltip>
													</h5>
													<h5 className="text-no-wrap color-00">
														{formatMoney(item.balance)}
													</h5>
												</b>
											</div>
										</div>
									)
								})()
							}
							{activeTab === 'couriers' &&
								<div style={{ 'height': '100%', 'overflow': 'auto' }}>
									<table className="table table-bordered table-bordered-custom">
										<thead>
											<tr>
												<th className="text-start"><b>{t('courier')}</b></th>
												<th className="text-end"><b>{t('quantity')}</b></th>
												<th className="text-end"><b>{t('amount')}</b></th>
											</tr>
										</thead>
										<tbody>
											{xReportData?.couriers?.data?.map((item, index) => (
												<tr key={index}>
													<td className="text-start">{item.name}</td>
													<td className="text-end">{formatMoney(item.total_quantity)}</td>
													<td className="text-end">{formatMoney(item.total_amount)}</td>
												</tr>
											))}
										</tbody>
										<tfoot>
											<tr>
												<td><b>{t('total')}</b></td>
												<td className="text-end">
													<b>{formatMoney(xReportData.couriers.total_quantity)}</b>
												</td>
												<td className="text-end">
													<b>{formatMoney(xReportData.couriers.total_amount)}</b>
												</td>
											</tr>
										</tfoot>
									</table>
								</div>
							}
							{activeTab === 'ingredients' &&
								<div style={{ 'height': '100%', 'overflow': 'auto' }}>
									<table className="table table-bordered table-bordered-custom">
										<thead>
											<tr>
												<th className="text-center" style={{ 'width': '33px' }}><b>#</b></th>
												<th className="text-start"><b>{t('element')}</b></th>
												<th className="text-start"><b>{t('category')}</b></th>
												<th className="text-start"><b>{t('unit')}</b></th>
												<th className="text-end"><b>{t('quantity')}</b></th>
											</tr>
										</thead>
										<tbody>
											{xReportData?.ingredients?.data?.map((item, index) => (
												<tr key={index}>
													<td className="text-center">{index + 1}</td>
													<td className="text-start">{item.name}</td>
													<td className="text-start">{item.category_name}</td>
													<td className="text-start">{item.unit_name}</td>
													<td className="text-end">{formatMoney(item.total_quantity, 2)}</td>
												</tr>
											))}
										</tbody>
										<tfoot>
											<tr>
												<td><b>{t('total')}</b></td>
												<td></td>
												<td></td>
												<td></td>
												<td className="text-end">
													<b>{formatMoney(xReportData.ingredients.total_quantity, 2)}</b>
												</td>
											</tr>
										</tfoot>
									</table>
								</div>
							}
							{activeTab === 'products_ingredients' &&
								<div style={{ 'height': '100%', 'overflow': 'auto' }}>
									<table className="table table-bordered table-bordered-custom">
										<thead>
											<tr>
												<th className="text-center" style={{ 'width': '33px' }}><b>#</b></th>
												<th className="text-start" ><b>{t('product')}</b></th>
												<th className="text-start"><b>{t('category')}</b></th>
												<th className="text-start"><b>{t('unit')}</b></th>
												<th className="text-end"><b>{t('quantity')}</b></th>
											</tr>
										</thead>
										<tbody>
											<TreeTable
												data={xReportData.products_ingredients.data}
												formatMoney={formatMoney}
											/>
										</tbody>
									</table>
								</div>
							}
							{activeTab === 'motivation_programs' &&
								<MotivationProgramsTable payload={xReportData?.motivation_programs} />
							}
						</div>
					</div>
				</Modal.Body>
			</Modal >
			{/* MODAL */}

			{/* ACCEPT CASHBOX MODAL */}
			<Modal show={showAcceptModal} animation={false} centered
				size="xl"
				dialogClassName="modal-accept-cashbox"
				onHide={() => setShowAcceptModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('accept_cashbox')}</Modal.Title>
				</Modal.Header>
				<form onSubmit={submitAcceptShift} className="d-flex flex-column" style={{ maxHeight: '75vh' }}>
					<Modal.Body style={{ overflowY: 'auto', flex: '1 1 auto' }}>
						<div className="mb-3">
							<div className="d-flex justify-content-between">
								<span>{t('shift')} ID</span>
								<span>{selectedItem?.id}</span>
							</div>
							<div className="d-flex justify-content-between">
								<span>{t('cashier')}</span>
								<span>{selectedItem?.cashier_name || xReportData?.x_report?.cashier_name}</span>
							</div>
							<div className="d-flex justify-content-between">
								<span>{t('cashbox_balance')}</span>
								<span>{formatMoney(selectedItem?.balance)}</span>
							</div>
						</div>

						<div className="table-responsive mb-3">
							<div className="fw-600 mb-1">{t('payment_types')}</div>
							<table className="table table-bordered mb-0">
								<thead>
									<tr>
										<th>{t('payment_types')}</th>
										<th className="text-end" style={{ 'width': '110px' }}>{t('system')}</th>
										<th className="text-end" style={{ 'width': '130px' }}>{t('fact')}</th>
										<th className="text-end" style={{ 'width': '90px' }}>{t('difference')}</th>
										<th style={{ 'minWidth': '200px' }}>{t('account')}</th>
									</tr>
								</thead>
								<tbody>
									{acceptPayments.map((item, index) => {
										const diff = (Number(item.amount) || 0) - (Number(item.system_amount) || 0)
										return (
											<tr key={index}>
												<td>{item.payment_type_name}</td>
												<td className="text-end">{formatMoney(item.system_amount)}</td>
												<td className="td-input">
													<input
														type="number"
														min="0"
														step="0.01"
														className="form-control text-end"
														value={item.amount}
														onChange={(e) => changeAcceptPaymentAmount(index, e.target.value)}
													/>
												</td>
												<td className={`text-end ${diff < 0 ? 'text-danger' : diff > 0 ? 'text-success' : ''}`}>
													{formatMoney(diff)}
												</td>
												<td>
													<Select
														isClearable
														{...accountSelectProps}
														value={accountOptions.find(option => option.id === item.account_id) || ''}
														onChange={(option) => changeAcceptPaymentAccount(index, option ? option.id : null)}
													/>
												</td>
											</tr>
										)
									})}
									{acceptPayments.length === 0 &&
										<tr>
											<td colSpan={5} className="text-center">{t('list_empty')}</td>
										</tr>
									}
								</tbody>
							</table>
						</div>

						<div className="table-responsive mb-3">
							<div className="fw-600 mb-1">{t('take_money')}</div>
							<table className="table table-bordered mb-0">
								<thead>
									<tr>
										<th>{t('payment_types')}</th>
										<th className="text-end" style={{ 'width': '110px' }}></th>
										<th className="text-end" style={{ 'width': '130px' }}>{t('fact')}</th>
										<th className="text-end" style={{ 'width': '90px' }}></th>
										<th style={{ 'minWidth': '200px' }}>{t('account')}</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>{t('cash')}</td>
										<td></td>
										<td className="text-end text-danger">{formatMoney(acceptExpenseCashAmount)}</td>
										<td></td>
										<td>
											<Select
												isClearable
												{...accountSelectProps}
												value={accountOptions.find(option => option.id === acceptExpenseCashAccountId) || ''}
												onChange={(option) => setAcceptExpenseCashAccountId(option ? option.id : null)}
											/>
										</td>
									</tr>
									<tr>
										<td>{t('terminal')}</td>
										<td></td>
										<td className="text-end text-danger">{formatMoney(acceptExpenseTerminalAmount)}</td>
										<td></td>
										<td>
											<Select
												isClearable
												{...accountSelectProps}
												value={accountOptions.find(option => option.id === acceptExpenseTerminalAccountId) || ''}
												onChange={(option) => setAcceptExpenseTerminalAccountId(option ? option.id : null)}
											/>
										</td>
									</tr>
								</tbody>
							</table>
						</div>

						<div className="table-responsive mb-3">
							<div className="fw-600 mb-1">{t('put_money')}</div>
							<table className="table table-bordered mb-0">
								<thead>
									<tr>
										<th>{t('payment_types')}</th>
										<th className="text-end" style={{ 'width': '110px' }}></th>
										<th className="text-end" style={{ 'width': '130px' }}>{t('fact')}</th>
										<th className="text-end" style={{ 'width': '90px' }}></th>
										<th style={{ 'minWidth': '200px' }}>{t('account')}</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>{t('cash')}</td>
										<td></td>
										<td className="text-end text-success">{formatMoney(acceptIncomeCashAmount)}</td>
										<td></td>
										<td>
											<Select
												isClearable
												{...accountSelectProps}
												value={accountOptions.find(option => option.id === acceptIncomeCashAccountId) || ''}
												onChange={(option) => setAcceptIncomeCashAccountId(option ? option.id : null)}
											/>
										</td>
									</tr>
									<tr>
										<td>{t('terminal')}</td>
										<td></td>
										<td className="text-end text-success">{formatMoney(acceptIncomeTerminalAmount)}</td>
										<td></td>
										<td>
											<Select
												isClearable
												{...accountSelectProps}
												value={accountOptions.find(option => option.id === acceptIncomeTerminalAccountId) || ''}
												onChange={(option) => setAcceptIncomeTerminalAccountId(option ? option.id : null)}
											/>
										</td>
									</tr>
								</tbody>
							</table>
						</div>

						{(() => {
							const totals = getAcceptTotals()
							const shortageAmount = totals.difference < 0 ? Math.abs(totals.difference) : 0
							const surplusAmount = totals.difference > 0 ? totals.difference : 0
							return (
								<>
									<div
										className="mb-3 border rounded"
										style={{ background: 'var(--dark-surface-2, #f8f9fa)', padding: '12px 14px' }}>
										<div className="d-flex justify-content-between align-items-start mb-2">
											<span>{t('total_cash')}</span>
											<div className="text-end">
												<div>
													<span className="text-muted me-2">{t('system')}</span>
													{formatMoney(totals.systemCashToAccount)}
												</div>
												<div>
													<span className="text-muted me-2">{t('fact')}</span>
													<b>{formatMoney(totals.cashToAccount)}</b>
												</div>
											</div>
										</div>
										<div className="d-flex justify-content-between align-items-start mb-2">
											<span>{t('total_bank')}</span>
											<div className="text-end">
												<div>
													<span className="text-muted me-2">{t('system')}</span>
													{formatMoney(totals.systemBankToAccount)}
												</div>
												<div>
													<span className="text-muted me-2">{t('fact')}</span>
													<b>{formatMoney(totals.bankToAccount)}</b>
												</div>
											</div>
										</div>
										<hr className="my-2" style={{ borderColor: 'var(--dark-border, #dee2e6)', opacity: 1 }} />
										{(Number(acceptExpenseCashAmount) > 0 || Number(acceptExpenseTerminalAmount) > 0) &&
											<div className="d-flex justify-content-between mb-1">
												<span>{t('take_money')}</span>
												<span className="text-danger">
													{formatMoney(
														(Number(acceptExpenseCashAmount) || 0)
														+ (Number(acceptExpenseTerminalAmount) || 0)
													)}
												</span>
											</div>
										}
										{(Number(acceptIncomeCashAmount) > 0 || Number(acceptIncomeTerminalAmount) > 0) &&
											<div className="d-flex justify-content-between mb-1">
												<span>{t('put_money')}</span>
												<span className="text-success">
													{formatMoney(
														(Number(acceptIncomeCashAmount) || 0)
														+ (Number(acceptIncomeTerminalAmount) || 0)
													)}
												</span>
											</div>
										}
										<div className="d-flex justify-content-between">
											<span>{t('difference')}</span>
											<span className={totals.difference < 0 ? 'text-danger' : totals.difference > 0 ? 'text-success' : ''}>
												{formatMoney(totals.difference)}
											</span>
										</div>
										{(() => {
											const acceptedCash =
												(Number(totals.cashToAccount) || 0)
												- (Number(acceptExpenseCashAmount) || 0)
												+ (Number(acceptIncomeCashAmount) || 0)
											const acceptedBank =
												(Number(totals.bankToAccount) || 0)
												- (Number(acceptExpenseTerminalAmount) || 0)
												+ (Number(acceptIncomeTerminalAmount) || 0)
											return (
												<div
													className="mt-2 pt-2"
													style={{ borderTop: '1px dashed var(--dark-border-strong, #adb5bd)' }}>
													<div className="d-flex justify-content-between align-items-start">
														<div>
															<b>Приняли у кассира</b>
															<div className="text-muted" style={{ fontSize: '12px' }}>
																{t('fact')} − {t('take_money')} + {t('put_money')}
															</div>
														</div>
														<div className="text-end">
															<div>
																<span className="text-muted me-2">{t('cash')}</span>
																<b>{formatMoney(acceptedCash)}</b>
															</div>
															{(acceptedBank !== 0 || (Number(totals.bankToAccount) || 0) !== 0) &&
																<div>
																	<span className="text-muted me-2">{t('terminal')}</span>
																	<b>{formatMoney(acceptedBank)}</b>
																</div>
															}
														</div>
													</div>
												</div>
											)
										})()}
									</div>

									{shortageAmount > 0 &&
										<div className="mb-3 p-2 border rounded">
											<div className="d-flex justify-content-between mb-2">
												<b>Недостача</b>
												<b className="text-danger">{formatMoney(shortageAmount)}</b>
											</div>
											<div className="form-group">
												<label>Куда отнести недостачу</label>
												<Select
													options={[
														{ id: 'account', name: 'На счёт' },
														{ id: 'employee_debt', name: 'На сотрудника (долг)' },
													]}
													value={[
														{ id: 'account', name: 'На счёт' },
														{ id: 'employee_debt', name: 'На сотрудника (долг)' },
													].find(option => option.id === acceptDifferenceDestination) || ''}
													onChange={(option) => {
														setAcceptDifferenceDestination(option ? option.id : null)
														setAcceptDifferenceAccountId(null)
														setAcceptDifferenceEmployeeId(null)
													}}
													menuPosition="fixed"
													menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
													menuPlacement="auto"
													styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											{acceptDifferenceDestination === 'account' &&
												<div className="form-group mb-0">
													<label>{t('account')}</label>
													<Select
														isClearable
														{...accountSelectProps}
														value={accountOptions.find(option => option.id === acceptDifferenceAccountId) || ''}
														onChange={(option) => setAcceptDifferenceAccountId(option ? option.id : null)}
													/>
												</div>
											}
											{acceptDifferenceDestination === 'employee_debt' &&
												<div className="form-group mb-0">
													<label>{t('employee')}</label>
													<Select
														isClearable
														options={acceptEmployees}
														value={acceptEmployees.find(option => option.id === acceptDifferenceEmployeeId) || ''}
														onChange={(option) => setAcceptDifferenceEmployeeId(option ? option.id : null)}
														menuPosition="fixed"
														menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
														menuPlacement="auto"
														styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
														placeholder=""
														noOptionsMessage={() => t('list_empty')}
														getOptionLabel={(option) => option.name}
														getOptionValue={(option) => option.id}
													/>
												</div>
											}
										</div>
									}

									{surplusAmount > 0 &&
										<div className="mb-3 p-2 border rounded">
											<div className="d-flex justify-content-between mb-2">
												<b>Излишек</b>
												<b className="text-success">{formatMoney(surplusAmount)}</b>
											</div>
											<div className="form-group mb-0">
												<label>Куда перенаправить излишек (счёт)</label>
												<Select
													isClearable
													{...accountSelectProps}
													value={accountOptions.find(option => option.id === acceptDifferenceAccountId) || ''}
													onChange={(option) => {
														setAcceptDifferenceDestination('account')
														setAcceptDifferenceAccountId(option ? option.id : null)
													}}
												/>
											</div>
										</div>
									}
								</>
							)
						})()}

						<div className="form-group mb-0">
							<label>{t('comment')}</label>
							<textarea
								className="form-control"
								rows={2}
								value={acceptNote}
								onChange={(e) => setAcceptNote(e.target.value)}
							/>
						</div>
					</Modal.Body>
					<Modal.Footer>
						<div className="d-flex w-100 gap-2">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => setShowAcceptModal(false)}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100" disabled={acceptLoading}>
								{t('accept')}
							</button>
						</div>
					</Modal.Footer>
				</form>
			</Modal>
			{/* ACCEPT CASHBOX MODAL */}

			{/* VIEW ACCEPTANCE MODAL */}
			<Modal show={showAcceptanceViewModal} animation={false} centered
				size="xl"
				onHide={() => setShowAcceptanceViewModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('cashbox_accepted')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{acceptanceView &&
						<>
							<div className="mb-3">
								<div className="d-flex justify-content-between mb-1">
									<span>{t('shift')} ID</span>
									<span>{acceptanceView.shift_id}</span>
								</div>
								<div className="d-flex justify-content-between mb-1">
									<span>{t('cashier')}</span>
									<span>{acceptanceView.cashier_name || selectedItem?.cashier_name || '—'}</span>
								</div>
								<div className="d-flex justify-content-between mb-1">
									<span>Принял</span>
									<span>
										{acceptanceView.accepted_by_name || acceptanceView.accepted_by_login || acceptanceView.created_by || '—'}
										{acceptanceView.created_at ? ` · ${formatDate(acceptanceView.created_at, 'dd.MM.yy HH:mm')}` : ''}
									</span>
								</div>
								<div className="d-flex justify-content-between">
									<span>{t('cashbox_balance')}</span>
									<span>{formatMoney(acceptanceView.shift_balance ?? selectedItem?.balance)}</span>
								</div>
							</div>

							<div className="table-responsive mb-3">
								<div className="fw-600 mb-1">{t('payment_types')}</div>
								<table className="table table-bordered mb-0">
									<thead>
										<tr>
											<th>{t('payment_types')}</th>
											<th className="text-end" style={{ 'width': '110px' }}>{t('system')}</th>
											<th className="text-end" style={{ 'width': '110px' }}>{t('fact')}</th>
											<th className="text-end" style={{ 'width': '90px' }}>{t('difference')}</th>
											<th>{t('account')}</th>
										</tr>
									</thead>
									<tbody>
										{(acceptanceView.payments || []).map((item, index) => {
											const diff = (Number(item.fact_amount) || 0) - (Number(item.system_amount) || 0)
											const categoryId = Number(item.payment_type_category_id)
											const accountName = item.account_name
												|| (categoryId === 1
													? acceptanceView.account_cash_name
													: (categoryId === 2 || categoryId === 5
														? acceptanceView.account_terminal_name
														: null))
											return (
												<tr key={index}>
													<td>{item.payment_type_name}</td>
													<td className="text-end">{formatMoney(item.system_amount)}</td>
													<td className="text-end">{formatMoney(item.fact_amount)}</td>
													<td className={`text-end ${diff < 0 ? 'text-danger' : diff > 0 ? 'text-success' : ''}`}>
														{formatMoney(diff)}
													</td>
													<td>{accountName || '—'}</td>
												</tr>
											)
										})}
										{(acceptanceView.payments || []).length === 0 &&
											<tr>
												<td colSpan={5} className="text-center">{t('list_empty')}</td>
											</tr>
										}
									</tbody>
								</table>
							</div>

							<div className="table-responsive mb-3">
								<div className="fw-600 mb-1">{t('take_money')}</div>
								<table className="table table-bordered mb-0">
									<thead>
										<tr>
											<th>{t('payment_types')}</th>
											<th className="text-end" style={{ 'width': '110px' }}></th>
											<th className="text-end" style={{ 'width': '110px' }}>{t('fact')}</th>
											<th className="text-end" style={{ 'width': '90px' }}></th>
											<th>{t('account')}</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td>{t('cash')}</td>
											<td></td>
											<td className="text-end text-danger">{formatMoney(acceptanceView.expense_cash_amount)}</td>
											<td></td>
											<td>{acceptanceView.expense_cash_account_name || acceptanceView.account_cash_name || '—'}</td>
										</tr>
										<tr>
											<td>{t('terminal')}</td>
											<td></td>
											<td className="text-end text-danger">{formatMoney(acceptanceView.expense_terminal_amount)}</td>
											<td></td>
											<td>{acceptanceView.expense_terminal_account_name || acceptanceView.account_terminal_name || '—'}</td>
										</tr>
									</tbody>
								</table>
							</div>

							<div className="table-responsive mb-3">
								<div className="fw-600 mb-1">{t('put_money')}</div>
								<table className="table table-bordered mb-0">
									<thead>
										<tr>
											<th>{t('payment_types')}</th>
											<th className="text-end" style={{ 'width': '110px' }}></th>
											<th className="text-end" style={{ 'width': '110px' }}>{t('fact')}</th>
											<th className="text-end" style={{ 'width': '90px' }}></th>
											<th>{t('account')}</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td>{t('cash')}</td>
											<td></td>
											<td className="text-end text-success">{formatMoney(acceptanceView.income_cash_amount)}</td>
											<td></td>
											<td>{acceptanceView.income_cash_account_name || acceptanceView.account_cash_name || '—'}</td>
										</tr>
										<tr>
											<td>{t('terminal')}</td>
											<td></td>
											<td className="text-end text-success">{formatMoney(acceptanceView.income_terminal_amount)}</td>
											<td></td>
											<td>{acceptanceView.income_terminal_account_name || acceptanceView.account_terminal_name || '—'}</td>
										</tr>
									</tbody>
								</table>
							</div>

							<div className="mb-3 p-2 border rounded">
								<div className="d-flex justify-content-between mb-1">
									<span>{t('cash')} ({t('fact')})</span>
									<span>{formatMoney(acceptanceView.cash_amount)}</span>
								</div>
								<div className="d-flex justify-content-between mb-1">
									<span>{t('terminal')} ({t('fact')})</span>
									<span>{formatMoney(acceptanceView.bank_amount)}</span>
								</div>
								<div className="d-flex justify-content-between">
									<span>{t('difference')}</span>
									<span className={
										Number(acceptanceView.difference_amount) > 0
											? (acceptanceView.difference_type === 'surplus' ? 'text-success' : 'text-danger')
											: ''
									}>
										{formatMoney(acceptanceView.difference_amount)}
										{Number(acceptanceView.difference_amount) > 0 &&
											` (${acceptanceView.difference_type === 'surplus' ? 'излишек' : 'недостача'})`
										}
									</span>
								</div>
								{(() => {
									const acceptedCash =
										(Number(acceptanceView.cash_amount) || 0)
										- (Number(acceptanceView.expense_cash_amount) || 0)
										+ (Number(acceptanceView.income_cash_amount) || 0)
									const acceptedBank =
										(Number(acceptanceView.bank_amount) || 0)
										- (Number(acceptanceView.expense_terminal_amount) || 0)
										+ (Number(acceptanceView.income_terminal_amount) || 0)
									return (
										<div className="mt-2 pt-2 border-top">
											<div className="d-flex justify-content-between align-items-start">
												<div>
													<b>Приняли у кассира</b>
													<div className="text-muted" style={{ fontSize: '12px' }}>
														{t('fact')} − {t('take_money')} + {t('put_money')}
													</div>
												</div>
												<div className="text-end">
													<div>
														<span className="text-muted me-2">{t('cash')}</span>
														<b>{formatMoney(acceptedCash)}</b>
													</div>
													{(acceptedBank !== 0 || (Number(acceptanceView.bank_amount) || 0) !== 0) &&
														<div>
															<span className="text-muted me-2">{t('terminal')}</span>
															<b>{formatMoney(acceptedBank)}</b>
														</div>
													}
												</div>
											</div>
										</div>
									)
								})()}
								{Number(acceptanceView.difference_amount) > 0 &&
									<div className="d-flex justify-content-between mt-1">
										<span>
											{acceptanceView.difference_type === 'surplus'
												? 'Куда перенаправлен излишек'
												: 'Куда отнесена недостача'}
										</span>
										<span>
											{acceptanceView.difference_destination === 'employee_debt'
												? `${t('employee')}: ${acceptanceView.difference_employee_name || '—'}`
												: acceptanceView.difference_destination === 'account'
													? acceptanceView.difference_account_name || '—'
													: '—'}
										</span>
									</div>
								}
							</div>

							{acceptanceView.note &&
								<div className="form-group mb-0">
									<label>{t('comment')}</label>
									<div className="form-control" style={{ 'minHeight': '60px', 'whiteSpace': 'pre-wrap' }}>
										{acceptanceView.note}
									</div>
								</div>
							}
						</>
					}
				</Modal.Body>
				<Modal.Footer>
					<button type="button" className="btn btn-outline-warning w-100"
						onClick={() => setShowAcceptanceViewModal(false)}>
						{t('cancel')}
					</button>
				</Modal.Footer>
			</Modal>
			{/* VIEW ACCEPTANCE MODAL */}

			{/* SHIFT EXPENSE / INCOME MODAL */}
			<Modal show={showShiftExpenseIncomeModal} animation={false} centered
				dialogClassName="update-modal-width"
				onHide={() => setShowShiftExpenseIncomeModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('expense')} / {t('income2')}</Modal.Title>
				</Modal.Header>
				<form onSubmit={submitShiftExpenseIncome} autoComplete="off">
					<Modal.Body>
						<div className="mb-3">
							<div className="d-flex justify-content-between mb-1">
								<span>{t('shift')} ID</span>
								<span>{selectedItem?.id}</span>
							</div>
							<div className="d-flex justify-content-between">
								<span>{t('cashier')}</span>
								<span>{selectedItem?.cashier_name || '—'}</span>
							</div>
						</div>

						<div className="btn-group w-100 mb-3">
							<button
								type="button"
								className={`btn ${shiftExpenseIncomeForm.transaction_type === 'minus' ? 'btn-danger' : 'btn-outline-danger'}`}
								disabled={shiftExpenseIncomeLoading}
								onClick={() => changeShiftExpenseIncomeType('minus')}>
								{t('expense')}
							</button>
							<button
								type="button"
								className={`btn ${shiftExpenseIncomeForm.transaction_type === 'plus' ? 'btn-success' : 'btn-outline-success'}`}
								disabled={shiftExpenseIncomeLoading}
								onClick={() => changeShiftExpenseIncomeType('plus')}>
								{t('income2')}
							</button>
						</div>

						<div className="form-group">
							<label>
								{shiftExpenseIncomeForm.transaction_type === 'plus' ? t('income_type') : t('expense_type')}
								<span className="required-mark">*</span>
							</label>
							<Select
								options={shiftExpenseIncomePpt}
								value={shiftExpenseIncomePpt.find(option => option.id === shiftExpenseIncomeForm.payment_purpose_id) || ''}
								onChange={(option) => handleShiftExpenseIncomePpt(option)}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
								menuPosition="fixed"
								menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
								styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
							/>
						</div>

						{!!shiftExpenseIncomeForm.counterparty &&
							<div className="form-group">
								<label>{t('counterparty')}<span className="required-mark">*</span></label>
								<Select
									options={shiftExpenseIncomeCounterparties}
									value={shiftExpenseIncomeCounterparties.find(option => option.id === shiftExpenseIncomeForm.counterparty_id) || ''}
									onChange={(option) => setShiftExpenseIncomeForm({
										...shiftExpenseIncomeForm,
										counterparty_id: option ? option.id : null,
									})}
									placeholder=""
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => option.name}
									getOptionValue={(option) => option.id}
									menuPosition="fixed"
									menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
									styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
								/>
							</div>
						}

						<div className="form-group">
							<label>{t('payment_types')}</label>
							<Select
								options={shiftExpenseIncomePaymentTypes}
								value={shiftExpenseIncomePaymentTypes.find(option => option.id === shiftExpenseIncomeForm.payment_type_id) || ''}
								onChange={(option) => setShiftExpenseIncomeForm({
									...shiftExpenseIncomeForm,
									payment_type_id: option ? option.id : null,
								})}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
								isClearable
								menuPosition="fixed"
								menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
								styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
							/>
						</div>

						<div className="form-group">
							<label>{t('amount')}<span className="required-mark">*</span></label>
							<input
								type="text"
								className="form-control"
								autoFocus
								value={shiftExpenseIncomeForm.amount ? formatMoneyInput(shiftExpenseIncomeForm.amount) : ''}
								onChange={(e) => setShiftExpenseIncomeForm({
									...shiftExpenseIncomeForm,
									amount: e.target.value.replace(/[^0-9.]/g, ''),
								})}
							/>
						</div>

						<div className="form-group mb-0">
							<label>{t('note')}</label>
							<input
								type="text"
								className="form-control"
								value={shiftExpenseIncomeForm.note || ''}
								onChange={(e) => setShiftExpenseIncomeForm({
									...shiftExpenseIncomeForm,
									note: e.target.value,
								})}
							/>
						</div>
					</Modal.Body>
					<Modal.Footer>
						<div className="d-flex gap-2 w-100">
							<button
								type="button"
								className="btn btn-outline-warning w-100"
								onClick={() => setShowShiftExpenseIncomeModal(false)}
								tabIndex="-1">
								{t('cancel')}
							</button>
							<button
								type="submit"
								className="btn btn-primary w-100"
								disabled={
									shiftExpenseIncomeLoading
									|| !(Number(shiftExpenseIncomeForm.amount) > 0)
									|| !shiftExpenseIncomeForm.payment_purpose_id
									|| (!!shiftExpenseIncomeForm.counterparty && !shiftExpenseIncomeForm.counterparty_id)
								}>
								{t('save')}
							</button>
						</div>
					</Modal.Footer>
				</form>
			</Modal>
			{/* SHIFT EXPENSE / INCOME MODAL */}

			<Rightbar Rightbar
				showRightBar={showRightBar}
				setShowRightBar={(value) => {
					setShowRightBar(value)
					if (!value) setRightbarItem({})
				}}
				selectedItem={rightbarItem} >
			</Rightbar >
		</>
	)
}

export default Shift
